var yr = Object.defineProperty;
var Sr = (e, t, n) => t in e ? yr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Wt = (e, t, n) => (Sr(e, typeof t != "symbol" ? t + "" : t, n), n);
import { ref as y, computed as M, openBlock as w, createElementBlock as I, createElementVNode as b, watch as re, unref as v, getCurrentInstance as xr, onMounted as Ze, nextTick as ve, getCurrentScope as Ir, onScopeDispose as Er, isRef as sn, watchEffect as et, reactive as Et, onBeforeUpdate as $r, markRaw as Tr, defineComponent as j, createBlock as B, resolveDynamicComponent as xo, normalizeClass as le, withCtx as O, renderSlot as ue, provide as Te, inject as Q, createCommentVNode as L, createVNode as x, normalizeStyle as Io, toDisplayString as X, onUnmounted as Bt, Fragment as _e, renderList as $t, cloneVNode as Or, h as ln, pushScopeId as kr, popScopeId as Cr, Transition as Dr, createTextVNode as pe, withKeys as Pr, useAttrs as Ar, withDirectives as Tt, mergeProps as Rn, vModelText as qr, vModelDynamic as Mr, vShow as jn } from "vue";
const Sn = {
  13: {
    id: 13,
    title: "",
    description: "",
    duration: 212,
    groupId: 8,
    streamUrl: "https://produktion.lohro.de/api/v1/audiofiles/13/stream"
  }
}, st = {
  8: {
    id: 8,
    title: "Ich h\xF6re was, was du nicht h\xF6rst mit Mattes",
    description: "Redakteur Mattes nimmt uns in diesem Beitrag in seinem Fantasie-Cabrio mit auf eine ganz besondere Reise in ferne Welten im Weltall und wandert dort durch einen Mix aus Gro\xDFstadt und Dschungel. Neugierig? Na dann: Kopfh\xF6rer auf, Augen zu und los geht's!"
  }
}, Eo = {
  1: {
    id: 1,
    sequenceId: 1,
    sourceSequenceId: 1,
    order: 0,
    nestedSequenceId: null,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: "Ich h\xF6re was, was du nicht h\xF6rst mit Mattes: Redakteur Mattes nimmt uns in diesem Beitrag in seinem Fantasie-Cabrio mit auf eine ganz besondere Reise in ferne Welten im Weltall und wandert dort durch einen Mix aus Gro\xDFstadt und Dschungel. Neugierig? Na dann: Kopfh\xF6rer auf, Augen zu und los geht's!",
    speakersText: ""
  },
  2: {
    id: 2,
    sequenceId: 1,
    sourceSequenceId: 1,
    order: 1,
    nestedSequenceId: null,
    audiofileId: 13,
    relativeStartTime: null,
    internalNote: "",
    speakersText: ""
  },
  3: {
    id: 3,
    sequenceId: 1,
    sourceSequenceId: 1,
    order: 2,
    nestedSequenceId: null,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: "",
    speakersText: "Jeder empfindet Musik anders. Unser Redakteur Mattes erz\xE4hlt euch heute seine Fantasien und Eindr\xFCcke zu einem Song, den er dabei gerade zum erstenmal h\xF6rt."
  },
  4: {
    id: 4,
    sequenceId: 1,
    sourceSequenceId: 1,
    order: 3,
    nestedSequenceId: null,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: "",
    speakersText: 'Das war eine interessante Reise durch Mattes Fantasien zu dem Song "Palm of my Hand" von ZHU. Vielleicht h\xF6rt ihr ja jetzt etwas anderes aus dem Song heraus. Hier ist ZHU mit "Palm of my Hand"'
  },
  5: {
    id: 5,
    sequenceId: 1,
    sourceSequenceId: 1,
    order: 4,
    nestedSequenceId: 2,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: "",
    speakersText: "Eingebetteter Beitrag"
  },
  6: {
    id: 6,
    sequenceId: 2,
    sourceSequenceId: 2,
    order: 0,
    nestedSequenceId: 3,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: "",
    speakersText: "Und jetzt kommt noch ein **sch\xF6nes** Lied"
  },
  7: {
    id: 7,
    sequenceId: 1,
    sourceSequenceId: 1,
    order: 5,
    nestedSequenceId: null,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: "",
    speakersText: "Moderation nach dem eingebetteten Beitrag"
  },
  8: {
    id: 8,
    sequenceId: 3,
    sourceSequenceId: 3,
    order: 0,
    nestedSequenceId: null,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: `!music(4m29s)

Kate Bush - Wuthering Heights`,
    speakersText: ""
  },
  9: {
    id: 9,
    sequenceId: 4,
    sourceSequenceId: 4,
    order: 0,
    nestedSequenceId: null,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: "Ein bisher nicht eingebetteter Beitrag",
    speakersText: ""
  }
}, Lt = {
  1: {
    id: 1,
    sourceSequenceId: 1,
    relatedObject: {
      title: "Ich h\xF6re was, was du nicht h\xF6rst mit Mattes",
      description: "Redakteur Mattes nimmt uns in diesem Beitrag in seinem Fantasie-Cabrio mit auf eine ganz besondere Reise in den Weltraum"
    }
  },
  2: {
    id: 2,
    sourceSequenceId: 2,
    relatedObject: {
      title: "Sch\xF6nes Liedmaterial",
      description: "Dies, Das, Musik, verschiedene K\xFCnstler*innen"
    }
  },
  3: {
    id: 3,
    sourceSequenceId: 3,
    relatedObject: {
      title: "Kate Bush Playlist",
      description: "Eine Playlist von Musik von Kate Bush"
    }
  },
  4: {
    id: 4,
    sourceSequenceId: 4,
    relatedObject: {
      title: "Hier geht\u2019s um Fundskerle und deren Gelder",
      description: "Dies Das Ananas"
    }
  }
};
async function Ot(e) {
  const t = [];
  for await (const n of e)
    t.push(n);
  return t;
}
function Nr(e, t) {
  return e.sort((n, o) => t(n) - t(o));
}
function $o(e) {
  const t = y(!1);
  return { isLoading: t, fn: async (...o) => {
    if (!t.value) {
      t.value = !0;
      try {
        return await e(...o);
      } finally {
        t.value = !1;
      }
    }
  } };
}
function Rr(e, t = 105) {
  return e.trim().split(/\s+/).length / t * 60;
}
const jr = (e, t, n) => n.indexOf(e) === t;
function* To(e, t) {
  const n = xn(e, t);
  for (const o of n)
    yield o, o.nestedSequenceId !== null && (yield* To(e, o.nestedSequenceId));
}
function Xt(e, t, n = 0) {
  return { level: n, order: e, data: t };
}
function zt(e, t) {
  t && (e = e.filter((n) => n.sequenceId === t)), e.forEach((n, o) => {
    n.order = o;
  });
}
function xn(e, t) {
  return Nr(
    e.filter((n) => n.sequenceId === t),
    (n) => n.order
  );
}
function* Fr(e, t) {
  e = Array.from(To(e, t));
  const n = [];
  let o = 0, r = Xt(o++, []);
  for (const a of e) {
    n.includes(a.sequenceId) ? n.splice(n.indexOf(a.sequenceId) + 1) : n.push(a.sequenceId);
    const s = Xt(a.order, a, n.length - 1);
    a.sequenceId === t && (r.data.length && (yield r), r = Xt(o++, [])), r.data.push(s);
  }
  r.data.length > 0 && (yield r);
}
const Oo = "temp-id-";
function un() {
  return Oo + Math.random().toString(36).substring(2, 9);
}
function He(e) {
  return e.toString().startsWith(Oo);
}
function ko(e) {
  var t, n;
  return {
    id: un(),
    sourceSequenceId: (t = e.sourceSequenceId) != null ? t : e.sequenceId,
    order: (n = e.order) != null ? n : 0,
    nestedSequenceId: null,
    audiofileId: null,
    relativeStartTime: null,
    internalNote: "",
    speakersText: "",
    ...e
  };
}
function Br(e, t, n = 0) {
  const o = ko({ sequenceId: t });
  e.splice(n, 0, o), zt(e, t);
}
function Lr(e, t, n, o) {
  const r = e.indexOf(n), a = ko({
    sequenceId: t,
    order: n.order
  });
  e.splice(o === "before" ? r : r + 1, 0, a), zt(e, n.sequenceId);
}
function zr(e, t, n, o) {
  const r = xn(e, t), a = r.splice(n, 1)[0];
  r.splice(o, 0, a), zt(r);
}
function Ur(e, t, n) {
  const o = e.indexOf(t);
  e.splice(o, 1), zt(xn(e, n));
}
function Hr(e, t, n) {
  if (t.nestedSequenceId === null)
    throw new Error("Cannot copy from a content sequence item that doesn\u2019t have a nested sequence.");
  const o = un(), r = e.findIndex(({ id: i }) => i === t.id), a = e.filter(
    ({ sequenceId: i }) => i === t.nestedSequenceId
  ), s = a.map((i) => ({
    ...i,
    id: un(),
    sequenceId: o,
    sourceSequenceId: n
  }));
  e.splice(r + 1, 0, ...s);
  for (const i of a) {
    const l = e.indexOf(i);
    e.splice(l, 1);
  }
  t.nestedSequenceId = o;
}
async function* kt(e, t) {
  for await (const n of e(t))
    yield n, n.nestedSequenceId !== null && (yield* await kt(e, n.nestedSequenceId));
}
Object.values(Sn).forEach((e) => {
  const t = st[e.groupId];
  !t || (e.title = e.title.trim() || t.title.trim(), e.description = e.description.trim() || t.description.trim());
});
const Fn = () => Math.random().toString(36).substring(2, 9);
class Co {
  constructor(t, n) {
    Wt(this, "_key");
    Wt(this, "_default");
    this._key = t, this._default = n;
  }
  get() {
    const t = localStorage.getItem(this._key);
    return t === null ? this._default : JSON.parse(t);
  }
  set(t) {
    localStorage.setItem(this._key, JSON.stringify(t));
  }
}
const cn = new Co(
  "csb::content-sequence",
  Lt
), Ct = new Co(
  "csb::content-sequence-items",
  Eo
);
function Vr() {
  cn.set(Lt), Ct.set(Eo), typeof location < "u" && location.reload();
}
function Yr() {
  return {
    "Reset Stores": Vr
  };
}
const Wr = (e) => Promise.resolve(Sn[e]), Xr = (e) => Promise.resolve(st[e]), Gr = (e) => Promise.resolve(Lt[e]);
async function* Do(e) {
  for (const t of Object.values(Ct.get()))
    t.sequenceId === e && (yield t);
}
async function* Kr(e, t) {
  var i, l, u, d, c, f;
  e = e.toLowerCase();
  const n = (i = t == null ? void 0 : t.page) != null ? i : 1, o = (l = t == null ? void 0 : t.pageSize) != null ? l : 10, r = (n - 1) * o;
  let a = 0, s = 0;
  for (const p of Object.values(Sn)) {
    const m = st == null ? void 0 : st[p.groupId];
    if (p.title.toLowerCase().includes(e) || p.description.toLowerCase().includes(e) || ((d = (u = m == null ? void 0 : m.title) == null ? void 0 : u.toLowerCase()) == null ? void 0 : d.includes(e)) || ((f = (c = m == null ? void 0 : m.description) == null ? void 0 : c.toLowerCase()) == null ? void 0 : f.includes(e))) {
      if (r > a++)
        continue;
      if (yield p, ++s > n)
        break;
    }
  }
}
async function* Zr(e, t, n) {
  var u, d;
  e = e.toLowerCase();
  const o = (u = n == null ? void 0 : n.page) != null ? u : 1, r = (d = n == null ? void 0 : n.pageSize) != null ? d : 10, a = (o - 1) * r;
  let s = 0, i = 0;
  const l = /* @__PURE__ */ new Set();
  for await (const c of await kt(
    Do,
    t.isEmbeddableIn
  ))
    l.add(c.sequenceId), l.add(c.sourceSequenceId), c.nestedSequenceId && l.add(c.nestedSequenceId);
  for (const c of Object.values(Lt))
    if (!!c.relatedObject && !l.has(c.id) && (c.relatedObject.title.toLowerCase().includes(e) || c.relatedObject.description.toLowerCase().includes(e))) {
      if (a > s++)
        continue;
      if (yield c, ++i > o)
        break;
    }
}
async function Qr(e, t) {
  const n = cn.get(), o = Ct.get(), r = {};
  function a(i) {
    if (!r[i]) {
      const l = Fn();
      r[i] = { id: l, sourceSequenceId: e, relatedObject: null }, n[l] = r[i];
    }
    return r[i];
  }
  for (const i of t)
    He(i.id) && (i.id = Fn()), i.nestedSequenceId && He(i.nestedSequenceId) && (i.nestedSequenceId = a(i.nestedSequenceId).id), He(i.sequenceId) && (i.sequenceId = a(i.sequenceId).id), o[i.id] = i;
  const s = Object.values(o).filter(
    (i) => i.sequenceId === e
  );
  for (const i of s)
    t.find((u) => u.id === i.id) || delete o[i.id];
  cn.set(n), Ct.set(o), await new Promise((i) => setTimeout(i, 1e3));
}
const $c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useAPIConfiguration: Yr,
  fetchAudiofile: Wr,
  fetchGroup: Xr,
  fetchContentSequence: Gr,
  fetchContentSequenceItems: Do,
  searchAudiofiles: Kr,
  searchContentSequences: Zr,
  saveContentSequenceItems: Qr
}, Symbol.toStringTag, { value: "Module" }));
function Jr(e) {
  var n;
  if (typeof document > "u")
    return;
  const t = ((n = document == null ? void 0 : document.cookie) != null ? n : "").split(";").map((o) => o.trim()).map((o) => {
    const [r, a] = o.split("=", 2);
    return { key: r, value: decodeURIComponent(a) };
  }).find((o) => o.key === e);
  return t == null ? void 0 : t.value;
}
var So;
const Ie = y(
  (So = { BASE_URL: "./", MODE: "production", DEV: !1, PROD: !0 }.VITE_LOHROTHEK_API) != null ? So : typeof location > "u" ? "http://localhost:8000/api" : `${location.origin}/api`
), Po = y(""), ei = M(() => {
  if (!(typeof location > "u"))
    return new URL(Ie.value).origin === window.location.origin ? "same-origin" : "include";
});
function ti(e, t) {
  for (const [n, o] of t)
    e[o] = e[n], delete e[n];
  return e;
}
function Re(e, t) {
  var o;
  t = t != null ? t : {}, t.credentials = ei.value, t.headers = new Headers((o = t.headers) != null ? o : {});
  const n = Po.value || Jr("csrftoken");
  return n && t.headers.set("x-csrftoken", n), window.fetch(e, t);
}
function Ao(e) {
  const t = Object.fromEntries(
    Object.entries(e).filter(([, n]) => typeof n < "u" && n !== null).map(([n, o]) => [n, String(o)])
  );
  return new URLSearchParams(t).toString();
}
const qo = (e) => ti(e, [["reportId", "groupId"]]);
function ni() {
  return { apiBaseUrl: Ie, csrfToken: Po };
}
async function oi(e) {
  return await (await Re(`${Ie.value}/internal/sequences/${e}/`)).json();
}
async function* Mo(e) {
  let t = `${Ie.value}/internal/sequence-items/?sequence=${e}`;
  for (; t; ) {
    const n = await Re(t), { next: o, results: r } = await n.json();
    yield* r, t = o;
  }
}
async function ri(e) {
  const t = await Re(`${Ie.value}/internal/audiofiles/${e}/`);
  return qo(await t.json());
}
async function ii(e) {
  return await (await Re(`${Ie.value}/internal/radio-reports/${e}/`)).json();
}
async function* ai(e, t) {
  const n = Ao({ page: t == null ? void 0 : t.page, pageSize: t == null ? void 0 : t.pageSize, search: e }), o = await Re(`${Ie.value}/internal/audiofiles/?${n}`), { results: r, detail: a } = await o.json();
  a || (yield* r.map(qo));
}
async function* si(e, t, n) {
  const o = Ao({
    page: n == null ? void 0 : n.page,
    pageSize: n == null ? void 0 : n.pageSize,
    search: e,
    ...t
  }), r = await Re(`${Ie.value}/internal/sequences/?${o}`), { results: a, detail: s } = await r.json();
  s || (yield* a);
}
function Bn(e, t, n) {
  return Re(t, {
    method: e,
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(n)
  });
}
async function li(e, t) {
  const n = `${Ie.value}/internal/sequence-items/`, o = await Ot(Mo(e)), r = [], a = {};
  async function s(i) {
    if (typeof a[i] > "u") {
      const l = await Bn("POST", `${Ie.value}/internal/sequences/`, {
        sourceSequenceId: e
      });
      a[i] = await l.json();
    }
    return a[i];
  }
  for (const i of t)
    i.nestedSequenceId && He(i.nestedSequenceId) && (i.nestedSequenceId = (await s(i.nestedSequenceId)).id), He(i.sequenceId) && (i.sequenceId = (await s(i.sequenceId)).id);
  for (const i of t) {
    const [l, u] = He(i.id) ? [n, "POST"] : [`${n}${i.id}/`, "PUT"], d = { ...i };
    delete d.id, delete d.sourceSequenceId, r.push(Bn(u, l, d));
  }
  for (const i of o)
    t.find((u) => u.id === i.id) || r.push(Re(`${n}/${i.id}/`, { method: "DELETE" }));
  await Promise.all(r);
}
const Tc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useAPIConfiguration: ni,
  fetchContentSequence: oi,
  fetchContentSequenceItems: Mo,
  fetchAudiofile: ri,
  fetchGroup: ii,
  searchAudiofiles: ai,
  searchContentSequences: si,
  saveContentSequenceItems: li
}, Symbol.toStringTag, { value: "Module" })), ui = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, ci = /* @__PURE__ */ b("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7 5h2v2H7zm5 0h2v2h-2zM7 9h2v2H7zm5 0h2v2h-2zm-5 4h2v2H7zm5 0h2v2h-2z"
}, null, -1), di = [
  ci
];
function fi(e, t) {
  return w(), I("svg", ui, di);
}
const pi = { name: "system-uicons-drag-vertical", render: fi }, mi = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 256 256",
  width: "1.2em",
  height: "1.2em"
}, hi = /* @__PURE__ */ b("path", {
  fill: "currentColor",
  d: "M224.4 104.2c-3.9-4.1-7.9-8.3-9.5-12.2s-1.6-9-1.7-14.7c-.1-9.3-.3-20-7.4-27.1s-17.8-7.3-27.1-7.4c-5.7-.1-11.1-.2-14.7-1.7s-8.1-5.6-12.2-9.5C145.2 25.2 137.6 18 128 18s-17.2 7.2-23.8 13.6c-4.1 3.9-8.3 7.9-12.2 9.5s-9 1.6-14.7 1.7c-9.3.1-20 .3-27.1 7.4S42.9 68 42.8 77.3c-.1 5.7-.2 11.1-1.7 14.7s-5.6 8.1-9.5 12.2C25.2 110.8 18 118.4 18 128s7.2 17.2 13.6 23.8c3.9 4.1 7.9 8.3 9.5 12.2s1.6 9 1.7 14.7c.1 9.3.3 20 7.4 27.1s17.8 7.3 27.1 7.4c5.7.1 11.1.2 14.7 1.7s8.1 5.6 12.2 9.5c6.6 6.4 14.2 13.6 23.8 13.6s17.2-7.2 23.8-13.6c4.1-3.9 8.3-7.9 12.2-9.5s9-1.6 14.7-1.7c9.3-.1 20-.3 27.1-7.4s7.3-17.8 7.4-27.1c.1-5.7.2-11.1 1.7-14.7s5.6-8.1 9.5-12.2c6.4-6.6 13.6-14.2 13.6-23.8s-7.2-17.2-13.6-23.8Zm-8.6 39.3c-4.7 4.9-9.5 9.9-12 15.9s-2.5 12.5-2.6 19.1s-.2 15.1-3.9 18.8s-11.4 3.8-18.8 3.9s-13.4.2-19.1 2.6s-11 7.3-15.9 12S132.8 226 128 226s-10.2-5.2-15.5-10.2s-9.9-9.5-15.9-12s-12.5-2.5-19.1-2.6s-15.1-.2-18.8-3.9s-3.8-11.4-3.9-18.8s-.2-13.4-2.6-19.1s-7.3-11-12-15.9S30 132.8 30 128s5.2-10.2 10.2-15.5s9.5-9.9 12-15.9s2.5-12.5 2.6-19.1s.2-15.1 3.9-18.8s11.4-3.8 18.8-3.9s13.4-.2 19.1-2.6s11-7.3 15.9-12S123.2 30 128 30s10.2 5.2 15.5 10.2s9.9 9.5 15.9 12s12.5 2.5 19.1 2.6s15.1.2 18.8 3.9s3.8 11.4 3.9 18.8s.2 13.4 2.6 19.1s7.3 11 12 15.9S226 123.2 226 128s-5.2 10.2-10.2 15.5ZM138 180a10 10 0 1 1-10-10a10 10 0 0 1 10 10Zm24-72a34.1 34.1 0 0 1-28 33.5v2.5a6 6 0 0 1-12 0v-8a6 6 0 0 1 6-6a22 22 0 1 0-22-22a6 6 0 0 1-12 0a34 34 0 0 1 68 0Z"
}, null, -1), vi = [
  hi
];
function gi(e, t) {
  return w(), I("svg", mi, vi);
}
const wi = { name: "ph-circle-wavy-question-light", render: gi }, _i = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 256 256",
  width: "1.2em",
  height: "1.2em"
}, bi = /* @__PURE__ */ b("path", {
  fill: "currentColor",
  d: "M211.7 27.3a5.8 5.8 0 0 0-5.2-1.1l-128 32A5.9 5.9 0 0 0 74 64v114.1A34 34 0 1 0 86 204V68.7l116-29v106.4a34 34 0 1 0 12 25.9V32a6.1 6.1 0 0 0-2.3-4.7ZM52 226a22 22 0 1 1 22-22a22.1 22.1 0 0 1-22 22Zm128-32a22 22 0 1 1 22-22a22.1 22.1 0 0 1-22 22Z"
}, null, -1), yi = [
  bi
];
function Si(e, t) {
  return w(), I("svg", _i, yi);
}
const xi = { name: "ph-music-notes-simple-light", render: Si }, Ii = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Ei = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6.5 8.5v4m2-6v9m2-6v2m2-4v6.814m2-9.814v12"
}, null, -1), $i = [
  Ei
];
function Ti(e, t) {
  return w(), I("svg", Ii, $i);
}
const In = { name: "system-uicons-audio-wave", render: Ti }, Oi = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, ki = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "m13.5 14.5l4-4l-4-4m4 4h-11m-3-7v14"
}, null, -1), Ci = [
  ki
];
function Di(e, t) {
  return w(), I("svg", Oi, Ci);
}
const Ut = { name: "system-uicons-pull-right", render: Di }, Pi = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 256 256",
  width: "1.2em",
  height: "1.2em"
}, Ai = /* @__PURE__ */ b("path", {
  fill: "currentColor",
  d: "M128 26a102 102 0 1 0 102 102A102.2 102.2 0 0 0 128 26Zm0 192a90 90 0 1 1 90-90a90.1 90.1 0 0 1-90 90Zm14-42a6 6 0 0 1-6 6h-8a6 6 0 0 1-6-6v-50h-2a6 6 0 0 1 0-12h8a6 6 0 0 1 6 6v50h2a6 6 0 0 1 6 6Zm-26-92a10 10 0 1 1 10 10a10 10 0 0 1-10-10Z"
}, null, -1), qi = [
  Ai
];
function Mi(e, t) {
  return w(), I("svg", Pi, qi);
}
const En = { name: "ph-info-light", render: Mi }, Ni = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Ri = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M11 16.517c4.418 0 8-3.284 8-7.017C19 5.767 15.418 3 11 3S3 6.026 3 9.759c0 1.457.546 2.807 1.475 3.91L3.5 18.25l3.916-2.447a9.181 9.181 0 0 0 3.584.714z"
}, null, -1), ji = [
  Ri
];
function Fi(e, t) {
  return w(), I("svg", Ni, ji);
}
const $n = { name: "system-uicons-speech-bubble", render: Fi };
var Ln;
const Tn = typeof window < "u", No = (e) => typeof e == "function", Bi = (e) => typeof e == "string", Li = () => +Date.now(), Ve = () => {
};
Tn && ((Ln = window == null ? void 0 : window.navigator) == null ? void 0 : Ln.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function Qe(e) {
  return typeof e == "function" ? e() : v(e);
}
function On(e, t) {
  function n(...o) {
    e(() => t.apply(this, o), { fn: t, thisArg: this, args: o });
  }
  return n;
}
const Ro = (e) => e();
function jo(e, t = {}) {
  let n, o;
  return (a) => {
    const s = Qe(e), i = Qe(t.maxWait);
    if (n && clearTimeout(n), s <= 0 || i !== void 0 && i <= 0)
      return o && (clearTimeout(o), o = null), a();
    i && !o && (o = setTimeout(() => {
      n && clearTimeout(n), o = null, a();
    }, i)), n = setTimeout(() => {
      o && clearTimeout(o), o = null, a();
    }, s);
  };
}
function zi(e, t = !0, n = !0) {
  let o = 0, r, a = !0;
  const s = () => {
    r && (clearTimeout(r), r = void 0);
  };
  return (l) => {
    const u = Qe(e), d = Date.now() - o;
    if (s(), u <= 0)
      return o = Date.now(), l();
    d > u && (n || !a) ? (o = Date.now(), l()) : t && (r = setTimeout(() => {
      o = Date.now(), a = !0, s(), l();
    }, u)), !n && !r && (r = setTimeout(() => a = !0, u)), a = !1;
  };
}
function Ui(e = Ro) {
  const t = y(!0);
  function n() {
    t.value = !1;
  }
  function o() {
    t.value = !0;
  }
  return { isActive: t, pause: n, resume: o, eventFilter: (...a) => {
    t.value && e(...a);
  } };
}
function Hi(e) {
  return e;
}
function kn(e) {
  return Ir() ? (Er(e), !0) : !1;
}
function Cn(e, t = 200, n = {}) {
  return On(jo(t, n), e);
}
function Vi(e, t = 200, n = {}) {
  if (t <= 0)
    return e;
  const o = y(e.value), r = Cn(() => {
    o.value = e.value;
  }, t, n);
  return re(e, () => r()), o;
}
function Yi(e, t = 200, n = !1, o = !0) {
  return On(zi(t, n, o), e);
}
function Fo(e, t = !0) {
  xr() ? Ze(e) : t ? e() : ve(e);
}
function Wi(e, t, n = {}) {
  const {
    immediate: o = !0
  } = n, r = y(!1);
  let a = null;
  function s() {
    a && (clearTimeout(a), a = null);
  }
  function i() {
    r.value = !1, s();
  }
  function l(...u) {
    s(), r.value = !0, a = setTimeout(() => {
      r.value = !1, a = null, e(...u);
    }, Qe(t));
  }
  return o && (r.value = !0, Tn && l()), kn(i), {
    isPending: r,
    start: l,
    stop: i
  };
}
var Xi = Object.defineProperty, zn = Object.getOwnPropertySymbols, Gi = Object.prototype.hasOwnProperty, Ki = Object.prototype.propertyIsEnumerable, Un = (e, t, n) => t in e ? Xi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Zi = (e, t) => {
  for (var n in t || (t = {}))
    Gi.call(t, n) && Un(e, n, t[n]);
  if (zn)
    for (var n of zn(t))
      Ki.call(t, n) && Un(e, n, t[n]);
  return e;
};
function Qi(e = 1e3, t = {}) {
  const {
    controls: n = !1
  } = t, o = Wi(Ve, e, t), r = M(() => !o.isPending.value);
  return n ? Zi({
    ready: r
  }, o) : r;
}
var Ji = Object.defineProperty, ea = Object.defineProperties, ta = Object.getOwnPropertyDescriptors, Dt = Object.getOwnPropertySymbols, Bo = Object.prototype.hasOwnProperty, Lo = Object.prototype.propertyIsEnumerable, Hn = (e, t, n) => t in e ? Ji(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, na = (e, t) => {
  for (var n in t || (t = {}))
    Bo.call(t, n) && Hn(e, n, t[n]);
  if (Dt)
    for (var n of Dt(t))
      Lo.call(t, n) && Hn(e, n, t[n]);
  return e;
}, oa = (e, t) => ea(e, ta(t)), ra = (e, t) => {
  var n = {};
  for (var o in e)
    Bo.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && Dt)
    for (var o of Dt(e))
      t.indexOf(o) < 0 && Lo.call(e, o) && (n[o] = e[o]);
  return n;
};
function ia(e, t, n = {}) {
  const o = n, {
    eventFilter: r = Ro
  } = o, a = ra(o, [
    "eventFilter"
  ]), s = On(r, t);
  let i, l, u;
  if (a.flush === "sync") {
    const d = y(!1);
    l = () => {
    }, i = (c) => {
      d.value = !0, c(), d.value = !1;
    }, u = re(e, (...c) => {
      d.value || s(...c);
    }, a);
  } else {
    const d = [], c = y(0), f = y(0);
    l = () => {
      c.value = f.value;
    }, d.push(re(e, () => {
      f.value++;
    }, oa(na({}, a), { flush: "sync" }))), i = (p) => {
      const m = f.value;
      p(), c.value += f.value - m;
    }, d.push(re(e, (...p) => {
      const m = c.value > 0 && c.value === f.value;
      c.value = 0, f.value = 0, !m && s(...p);
    }, a)), u = () => {
      d.forEach((p) => p());
    };
  }
  return { stop: u, ignoreUpdates: i, ignorePrevAsyncUpdates: l };
}
function aa(e, t, n) {
  let o;
  sn(n) ? o = {
    evaluating: n
  } : o = n || {};
  const {
    lazy: r = !1,
    evaluating: a = void 0,
    onError: s = Ve
  } = o, i = y(!r), l = y(t);
  let u = 0;
  return et(async (d) => {
    if (!i.value)
      return;
    u++;
    const c = u;
    let f = !1;
    a && Promise.resolve().then(() => {
      a.value = !0;
    });
    try {
      const p = await e((m) => {
        d(() => {
          a && (a.value = !1), f || m();
        });
      });
      c === u && (l.value = p);
    } catch (p) {
      s(p);
    } finally {
      a && c === u && (a.value = !1), f = !0;
    }
  }), r ? M(() => (i.value = !0, l.value)) : l;
}
function Me(e) {
  var t;
  const n = Qe(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Dn = Tn ? window : void 0;
function Ue(...e) {
  let t, n, o, r;
  if (Bi(e[0]) ? ([n, o, r] = e, t = Dn) : [t, n, o, r] = e, !t)
    return Ve;
  let a = Ve;
  const s = re(() => Me(t), (l) => {
    a(), l && (l.addEventListener(n, o, r), a = () => {
      l.removeEventListener(n, o, r), a = Ve;
    });
  }, { immediate: !0, flush: "post" }), i = () => {
    s(), a();
  };
  return kn(i), i;
}
function sa(e, t, n = {}) {
  const { window: o = Dn, ignore: r, capture: a = !0, detectIframe: s = !1 } = n;
  if (!o)
    return;
  const i = y(!0);
  let l;
  const u = (f) => {
    o.clearTimeout(l);
    const p = Me(e), m = f.composedPath();
    !p || p === f.target || m.includes(p) || !i.value || r && r.length > 0 && r.some((h) => {
      const _ = Me(h);
      return _ && (f.target === _ || m.includes(_));
    }) || t(f);
  }, d = [
    Ue(o, "click", u, { passive: !0, capture: a }),
    Ue(o, "pointerdown", (f) => {
      const p = Me(e);
      i.value = !!p && !f.composedPath().includes(p);
    }, { passive: !0 }),
    Ue(o, "pointerup", (f) => {
      if (f.button === 0) {
        const p = f.composedPath();
        f.composedPath = () => p, l = o.setTimeout(() => u(f), 50);
      }
    }, { passive: !0 }),
    s && Ue(o, "blur", (f) => {
      var p;
      const m = Me(e);
      ((p = document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(m != null && m.contains(document.activeElement)) && t(f);
    })
  ].filter(Boolean);
  return () => d.forEach((f) => f());
}
function la(e, t = !1) {
  const n = y(), o = () => n.value = Boolean(e());
  return o(), Fo(o, t), n;
}
const dn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, fn = "__vueuse_ssr_handlers__";
dn[fn] = dn[fn] || {};
dn[fn];
const zo = (e) => JSON.parse(JSON.stringify(e)), Uo = (e) => e, ua = (e, t) => e.value = t;
function ca(e) {
  return e ? No(e) ? e : zo : Uo;
}
function da(e) {
  return e ? No(e) ? e : zo : Uo;
}
function fa(e, t = {}) {
  const {
    clone: n = !1,
    dump: o = ca(n),
    parse: r = da(n),
    setSource: a = ua
  } = t;
  function s() {
    return Tr({
      snapshot: o(e.value),
      timestamp: Li()
    });
  }
  const i = y(s()), l = y([]), u = y([]), d = (D) => {
    a(e, r(D.snapshot)), i.value = D;
  }, c = () => {
    l.value.unshift(i.value), i.value = s(), t.capacity && l.value.length > t.capacity && l.value.splice(t.capacity, 1 / 0), u.value.length && u.value.splice(0, u.value.length);
  }, f = () => {
    l.value.splice(0, l.value.length), u.value.splice(0, u.value.length);
  }, p = () => {
    const D = l.value.shift();
    D && (u.value.unshift(i.value), d(D));
  }, m = () => {
    const D = u.value.shift();
    D && (l.value.unshift(i.value), d(D));
  }, h = () => {
    d(i.value);
  }, _ = M(() => [i.value, ...l.value]), P = M(() => l.value.length > 0), C = M(() => u.value.length > 0);
  return {
    source: e,
    undoStack: l,
    redoStack: u,
    last: i,
    history: _,
    canUndo: P,
    canRedo: C,
    clear: f,
    commit: c,
    reset: h,
    undo: p,
    redo: m
  };
}
var pa = Object.defineProperty, ma = Object.defineProperties, ha = Object.getOwnPropertyDescriptors, Vn = Object.getOwnPropertySymbols, va = Object.prototype.hasOwnProperty, ga = Object.prototype.propertyIsEnumerable, Yn = (e, t, n) => t in e ? pa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Wn = (e, t) => {
  for (var n in t || (t = {}))
    va.call(t, n) && Yn(e, n, t[n]);
  if (Vn)
    for (var n of Vn(t))
      ga.call(t, n) && Yn(e, n, t[n]);
  return e;
}, Xn = (e, t) => ma(e, ha(t));
function wa(e, t = {}) {
  const {
    deep: n = !1,
    flush: o = "pre",
    eventFilter: r
  } = t, {
    eventFilter: a,
    pause: s,
    resume: i,
    isActive: l
  } = Ui(r), {
    ignoreUpdates: u,
    ignorePrevAsyncUpdates: d,
    stop: c
  } = ia(e, _, { deep: n, flush: o, eventFilter: a });
  function f(z, H) {
    d(), u(() => {
      z.value = H;
    });
  }
  const p = fa(e, Xn(Wn({}, t), { clone: t.clone || n, setSource: f })), { clear: m, commit: h } = p;
  function _() {
    d(), h();
  }
  function P(z) {
    i(), z && _();
  }
  function C(z) {
    let H = !1;
    const S = () => H = !0;
    u(() => {
      z(S);
    }), H || _();
  }
  function D() {
    c(), m();
  }
  return Xn(Wn({}, p), {
    isTracking: l,
    pause: s,
    resume: P,
    commit: _,
    batch: C,
    dispose: D
  });
}
var _a = Object.defineProperty, ba = Object.defineProperties, ya = Object.getOwnPropertyDescriptors, Gn = Object.getOwnPropertySymbols, Sa = Object.prototype.hasOwnProperty, xa = Object.prototype.propertyIsEnumerable, Kn = (e, t, n) => t in e ? _a(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Zn = (e, t) => {
  for (var n in t || (t = {}))
    Sa.call(t, n) && Kn(e, n, t[n]);
  if (Gn)
    for (var n of Gn(t))
      xa.call(t, n) && Kn(e, n, t[n]);
  return e;
}, Ia = (e, t) => ba(e, ya(t));
function Ea(e, t = {}) {
  const n = t.debounce ? jo(t.debounce) : void 0, o = wa(e, Ia(Zn({}, t), { eventFilter: n }));
  return Zn({}, o);
}
var Qn = Object.getOwnPropertySymbols, $a = Object.prototype.hasOwnProperty, Ta = Object.prototype.propertyIsEnumerable, Oa = (e, t) => {
  var n = {};
  for (var o in e)
    $a.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && Qn)
    for (var o of Qn(e))
      t.indexOf(o) < 0 && Ta.call(e, o) && (n[o] = e[o]);
  return n;
};
function ka(e, t, n = {}) {
  const o = n, { window: r = Dn } = o, a = Oa(o, ["window"]);
  let s;
  const i = la(() => r && "ResizeObserver" in r), l = () => {
    s && (s.disconnect(), s = void 0);
  }, u = re(() => Me(e), (c) => {
    l(), i.value && r && c && (s = new ResizeObserver(t), s.observe(c, a));
  }, { immediate: !0, flush: "post" }), d = () => {
    l(), u();
  };
  return kn(d), {
    isSupported: i,
    stop: d
  };
}
function Ho(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: o = !0,
    windowScroll: r = !0,
    immediate: a = !0
  } = t, s = y(0), i = y(0), l = y(0), u = y(0), d = y(0), c = y(0), f = y(0), p = y(0);
  function m() {
    const h = Me(e);
    if (!h) {
      n && (s.value = 0, i.value = 0, l.value = 0, u.value = 0, d.value = 0, c.value = 0, f.value = 0, p.value = 0);
      return;
    }
    const _ = h.getBoundingClientRect();
    s.value = _.height, i.value = _.bottom, l.value = _.left, u.value = _.right, d.value = _.top, c.value = _.width, f.value = _.x, p.value = _.y;
  }
  return ka(e, m), re(() => Me(e), (h) => !h && m()), r && Ue("scroll", m, { passive: !0 }), o && Ue("resize", m, { passive: !0 }), Fo(() => {
    a && m();
  }), {
    height: s,
    bottom: i,
    left: l,
    right: u,
    top: d,
    width: c,
    x: f,
    y: p,
    update: m
  };
}
function Ca(e, t = {}) {
  const {
    throttle: n = 0,
    idle: o = 200,
    onStop: r = Ve,
    onScroll: a = Ve,
    offset: s = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: i = {
      capture: !1,
      passive: !0
    }
  } = t, l = y(0), u = y(0), d = y(!1), c = Et({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), f = Et({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), p = Cn((h) => {
    d.value = !1, f.left = !1, f.right = !1, f.top = !1, f.bottom = !1, r(h);
  }, n + o), m = (h) => {
    const _ = h.target === document ? h.target.documentElement : h.target, P = _.scrollLeft;
    f.left = P < l.value, f.right = P > l.value, c.left = P <= 0 + (s.left || 0), c.right = P + _.clientWidth >= _.scrollWidth - (s.right || 0), l.value = P;
    let C = _.scrollTop;
    h.target === document && !C && (C = document.body.scrollTop), f.top = C < u.value, f.bottom = C > u.value, c.top = C <= 0 + (s.top || 0), c.bottom = C + _.clientHeight >= _.scrollHeight - (s.bottom || 0), u.value = C, d.value = !0, p(h), a(h);
  };
  return Ue(e, "scroll", n ? Yi(m, n) : m, i), {
    x: l,
    y: u,
    isScrolling: d,
    arrivedState: c,
    directions: f
  };
}
var Da = Object.defineProperty, Pa = Object.defineProperties, Aa = Object.getOwnPropertyDescriptors, Jn = Object.getOwnPropertySymbols, qa = Object.prototype.hasOwnProperty, Ma = Object.prototype.propertyIsEnumerable, eo = (e, t, n) => t in e ? Da(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, to = (e, t) => {
  for (var n in t || (t = {}))
    qa.call(t, n) && eo(e, n, t[n]);
  if (Jn)
    for (var n of Jn(t))
      Ma.call(t, n) && eo(e, n, t[n]);
  return e;
}, Na = (e, t) => Pa(e, Aa(t));
function Ra(e, t, n = {}) {
  var o, r;
  const a = (o = n.direction) != null ? o : "bottom", s = Et(Ca(e, Na(to({}, n), {
    offset: to({
      [a]: (r = n.distance) != null ? r : 0
    }, n.offset)
  })));
  re(() => s.arrivedState[a], async (i) => {
    var l, u;
    if (i) {
      const d = Qe(e), c = {
        height: (l = d == null ? void 0 : d.scrollHeight) != null ? l : 0,
        width: (u = d == null ? void 0 : d.scrollWidth) != null ? u : 0
      };
      await t(s), n.preserveScrollPosition && d && ve(() => {
        d.scrollTo({
          top: d.scrollHeight - c.height,
          left: d.scrollWidth - c.width
        });
      });
    }
  });
}
var no;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(no || (no = {}));
function ja() {
  const e = y([]);
  return e.value.set = (t) => {
    t && e.value.push(t);
  }, $r(() => {
    e.value.length = 0;
  }), e;
}
var Fa = Object.defineProperty, oo = Object.getOwnPropertySymbols, Ba = Object.prototype.hasOwnProperty, La = Object.prototype.propertyIsEnumerable, ro = (e, t, n) => t in e ? Fa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, za = (e, t) => {
  for (var n in t || (t = {}))
    Ba.call(t, n) && ro(e, n, t[n]);
  if (oo)
    for (var n of oo(t))
      La.call(t, n) && ro(e, n, t[n]);
  return e;
};
const Ua = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
za({
  linear: Hi
}, Ua);
function Ha(e) {
  const t = Math.floor(e / 3600), n = Math.floor(e % 3600 / 60), o = Math.round(e % 60);
  return `${t ? t + "h " : ""}${n ? n + "min " : ""}${o ? o + "s" : ""}`;
}
function Vo(e) {
  const t = Math.floor(e / 3600), n = Math.floor(e % 3600 / 60), o = Math.round(e % 60);
  return [t, n, o].map((r) => r.toString().padStart(2, "0")).join(":");
}
function Va(e, t, n) {
  return Array(Math.max(0, t - e.length)).fill(n).concat(e);
}
function Pt(e) {
  var a, s;
  let [t, n, o, r] = Array(4).fill(0);
  if (e.includes(":"))
    [t, n, o, r] = Va(e.split(":"), 4, 0);
  else {
    const i = /^\s*(?:(?<days>\d+)\s*d)?\s*(?:(?<hours>\d+)\s*h)?\s*(?:(?<minutes>\d+)\s*m(?:in)?)?\s*(?:(?<seconds>\d+)\s*s?)?\s*$/;
    ({ days: t, hours: n, minutes: o, seconds: r } = (s = (a = e.match(i)) == null ? void 0 : a.groups) != null ? s : {});
  }
  return parseInt(t || 0) * 24 * 60 * 60 + parseInt(n || 0) * 60 * 60 + parseInt(o || 0) * 60 + parseInt(r || 0);
}
const Ya = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Wa = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M17 4a2.121 2.121 0 0 1 0 3l-9.5 9.5l-4 1l1-3.944l9.504-9.552a2.116 2.116 0 0 1 2.864-.125zm-1.5 2.5l1 1"
}, null, -1), Xa = [
  Wa
];
function Ga(e, t) {
  return w(), I("svg", Ya, Xa);
}
const Ka = { name: "system-uicons-pen", render: Ga }, je = /* @__PURE__ */ j({
  __name: "AButton",
  props: {
    round: { type: Boolean, default: !1 },
    disabled: { type: Boolean },
    size: { default: "small" },
    flavour: { default: "gray" },
    is: { default: "button" }
  },
  setup(e) {
    const t = e, n = M(() => ({
      "tw-rounded": !t.round,
      "tw-rounded-full": t.round,
      "tw-text-sm tw-px-2 tw-py-1": t.size === "small",
      "tw-text-base tw-px-4 tw-py-2": t.size === "medium",
      "tw-text-2xl tw-px-6 tw-py-2": t.size === "large",
      "tw-bg-gray-100 tw-text-black/75": t.flavour === "gray",
      "hover:tw-bg-gray-200": t.flavour === "gray" && !t.disabled,
      "tw-bg-indigo-200": t.flavour === "indigo",
      "hover:tw-bg-indigo-500 hover:tw-text-white": t.flavour === "indigo" && !t.disabled,
      "hover:tw-bg-gray-100": t.flavour === "gray-blend" && !t.disabled,
      "hover:tw-text-indigo-500": t.flavour === "indigo-blend" && !t.disabled,
      "tw-cursor-deny tw-opacity-50 tw-grayscale-[30%] tw-saturate-[75%]": t.disabled,
      "tw-cursor-pointer": !t.disabled
    }));
    return (o, r) => (w(), B(xo(e.is), {
      class: le(["tw-inline-flex tw-font-semibold tw-items-center tw-gap-1 tw-select-none tw-transition-all tw-justify-center tw-origin-center", v(n)]),
      disabled: e.disabled
    }, {
      default: O(() => [
        ue(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "disabled"]));
  }
}), Za = ["data-csb-field"], Qa = { class: "tw-flex tw-items-center tw-gap-3" }, Ja = ["for"], es = { key: 2 }, At = /* @__PURE__ */ j({
  __name: "AField",
  props: {
    id: null,
    isEditing: { type: Boolean },
    allowEditing: { type: Boolean, default: !0 }
  },
  emits: ["edit"],
  setup(e, { emit: t }) {
    const n = e, o = y();
    async function r() {
      var s;
      t("edit", !0), await ve(), (s = o.value) == null || s.click();
    }
    Te("fieldId", n.id);
    const a = Q("i18n");
    return (s, i) => {
      const l = Ka;
      return w(), I("div", {
        class: "tw-mb-6 last:tw-mb-0",
        "data-csb-field": e.id
      }, [
        e.isEditing === !1 ? ue(s.$slots, "not-editing-pre", { key: 0 }) : L("", !0),
        b("header", Qa, [
          b("label", {
            ref_key: "label",
            ref: o,
            for: e.id
          }, [
            ue(s.$slots, "label")
          ], 8, Ja),
          e.isEditing === !1 && e.allowEditing ? (w(), B(je, {
            key: 0,
            round: "",
            size: "none",
            class: "tw-w-7 tw-h-7 tw-flex-none tw-opacity-0 group-hover:tw-opacity-100 focus-visible:tw-opacity-100",
            title: v(a).generic.edit,
            onClick: r
          }, {
            default: O(() => [
              x(l)
            ]),
            _: 1
          }, 8, ["title"])) : L("", !0)
        ]),
        e.isEditing === void 0 || e.isEditing ? ue(s.$slots, "default", {
          key: 1,
          id: e.id
        }) : L("", !0),
        e.isEditing === !1 ? (w(), I("div", es, [
          ue(s.$slots, "not-editing")
        ])) : L("", !0)
      ], 8, Za);
    };
  }
}), ts = { class: "tw-flex tw-relative -tw-top-2" }, ns = { class: "tw-text-lg tw-flex tw-flex-col tw-p-3 -tw-mt-1" }, os = ["aria-label", "title"], rs = { class: "tw-sr-only" }, is = ["id", "value"], as = { class: "tw-text-sm tw-text-gray-600" }, ss = /* @__PURE__ */ j({
  __name: "ATimelineItem",
  props: {
    item: null,
    topOffset: null,
    calculatedStartTime: null,
    hasInvalidStartTime: { type: Boolean }
  },
  emits: ["update:relativeStartTime"],
  setup(e, { emit: t }) {
    const n = Qi(1e3), o = y(!1), r = y();
    re(o, async (i) => {
      var l, u;
      i && (await ve(), (u = (l = r.value) == null ? void 0 : l.focus) == null || u.call(l));
    });
    function a(i) {
      var u;
      const l = ((u = i.target.value) != null ? u : "").trim();
      t("update:relativeStartTime", l ? Vo(Pt(l)) : null);
    }
    const s = Q("i18n");
    return (i, l) => {
      const u = $n, d = En, c = Ut, f = In, p = xi, m = wi;
      return w(), I("li", {
        class: le(["tw-absolute tw-max-w-full tw-left-0 tw-z-10 tw-group tw-text-gray-700", { "tw-transition-transform": v(n) }]),
        style: Io({ transform: `translateY(${e.item.position.top - e.topOffset}px)` })
      }, [
        b("div", ts, [
          b("div", {
            class: le(["tw-w-12 tw-h-12 tw-flex-none tw-rounded-full tw-translate-x-px tw-relative -tw-left-px tw-border tw-outline tw-outline-4 tw-outline-gray-100 tw-text-black/75 tw-flex tw-items-center tw-justify-center tw-p-1 tw-text-2xl", {
              "tw-bg-red-100 tw-border-red-300": e.item.type === "default",
              "tw-bg-green-100 tw-border-green-300": e.item.type === "audio",
              "tw-bg-amber-100 tw-border-amber-300": e.item.type === "music",
              "tw-bg-white tw-border-gray-300": ["moderation", "note", "embed"].includes(e.item.type)
            }])
          }, [
            e.item.type === "moderation" ? (w(), B(u, { key: 0 })) : e.item.type === "note" ? (w(), B(d, {
              key: 1,
              class: "tw-ml-px"
            })) : e.item.type === "embed" ? (w(), B(c, {
              key: 2,
              class: "tw-ml-1"
            })) : e.item.type === "audio" ? (w(), B(f, { key: 3 })) : e.item.type === "music" ? (w(), B(p, { key: 4 })) : (w(), B(m, { key: 5 }))
          ], 2),
          b("div", ns, [
            x(At, {
              id: `start-time-${e.item.id}`,
              "is-editing": o.value,
              class: "tw-flex tw-items-center tw-h-8 tw-mb-0",
              onEdit: l[1] || (l[1] = (h) => o.value = !0)
            }, {
              "not-editing-pre": O(() => {
                var h;
                return [
                  b("p", {
                    class: le(["tw-text-sm tw-font-bold tw-px-2 -tw-mx-2 tw-rounded", {
                      "tw-bg-rose-600 tw-text-white": e.hasInvalidStartTime,
                      "tw-text-indigo-500": !e.hasInvalidStartTime && e.item.relativeStartTime
                    }]),
                    "aria-label": v(s).sequenceItem.relativeStartTime,
                    title: e.hasInvalidStartTime ? v(s).sequenceItem.relativeStartTimeIssue : void 0
                  }, X((h = e.item.relativeStartTime) != null ? h : e.calculatedStartTime), 11, os)
                ];
              }),
              label: O(() => [
                b("span", rs, X(v(s).sequenceItem.relativeStartTime), 1)
              ]),
              default: O(({ id: h }) => {
                var _;
                return [
                  b("input", {
                    id: h,
                    ref_key: "relativeStartTimeInput",
                    ref: r,
                    type: "text",
                    class: "tw-bg-transparent tw-text-sm tw-w-[70px]",
                    value: (_ = e.item.relativeStartTime) != null ? _ : e.calculatedStartTime,
                    onChange: a,
                    onBlur: l[0] || (l[0] = (P) => o.value = !1)
                  }, null, 40, is)
                ];
              }),
              _: 1
            }, 8, ["id", "is-editing"]),
            b("p", as, X(v(Ha)(e.item.duration)), 1)
          ])
        ])
      ], 6);
    };
  }
});
/**!
 * Sortable 1.15.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function io(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ee(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? io(Object(n), !0).forEach(function(o) {
      ls(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : io(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function bt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? bt = function(t) {
    return typeof t;
  } : bt = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bt(e);
}
function ls(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ke() {
  return ke = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, ke.apply(this, arguments);
}
function us(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), r, a;
  for (a = 0; a < o.length; a++)
    r = o[a], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
function cs(e, t) {
  if (e == null)
    return {};
  var n = us(e, t), o, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      o = a[r], !(t.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (n[o] = e[o]));
  }
  return n;
}
var ds = "1.15.0";
function Oe(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var Ce = Oe(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), mt = Oe(/Edge/i), ao = Oe(/firefox/i), lt = Oe(/safari/i) && !Oe(/chrome/i) && !Oe(/android/i), Yo = Oe(/iP(ad|od|hone)/i), Wo = Oe(/chrome/i) && Oe(/android/i), Xo = {
  capture: !1,
  passive: !1
};
function N(e, t, n) {
  e.addEventListener(t, n, !Ce && Xo);
}
function q(e, t, n) {
  e.removeEventListener(t, n, !Ce && Xo);
}
function qt(e, t) {
  if (!!t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function fs(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function Se(e, t, n, o) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && qt(e, t) : qt(e, t)) || o && e === n)
        return e;
      if (e === n)
        break;
    } while (e = fs(e));
  }
  return null;
}
var so = /\s+/g;
function de(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var o = (" " + e.className + " ").replace(so, " ").replace(" " + t + " ", " ");
      e.className = (o + (n ? " " + t : "")).replace(so, " ");
    }
}
function E(e, t, n) {
  var o = e && e.style;
  if (o) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in o) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), o[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function Ke(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var o = E(e, "transform");
      o && o !== "none" && (n = o + " " + n);
    } while (!t && (e = e.parentNode));
  var r = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return r && new r(n);
}
function Go(e, t, n) {
  if (e) {
    var o = e.getElementsByTagName(t), r = 0, a = o.length;
    if (n)
      for (; r < a; r++)
        n(o[r], r);
    return o;
  }
  return [];
}
function xe() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function ee(e, t, n, o, r) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var a, s, i, l, u, d, c;
    if (e !== window && e.parentNode && e !== xe() ? (a = e.getBoundingClientRect(), s = a.top, i = a.left, l = a.bottom, u = a.right, d = a.height, c = a.width) : (s = 0, i = 0, l = window.innerHeight, u = window.innerWidth, d = window.innerHeight, c = window.innerWidth), (t || n) && e !== window && (r = r || e.parentNode, !Ce))
      do
        if (r && r.getBoundingClientRect && (E(r, "transform") !== "none" || n && E(r, "position") !== "static")) {
          var f = r.getBoundingClientRect();
          s -= f.top + parseInt(E(r, "border-top-width")), i -= f.left + parseInt(E(r, "border-left-width")), l = s + a.height, u = i + a.width;
          break;
        }
      while (r = r.parentNode);
    if (o && e !== window) {
      var p = Ke(r || e), m = p && p.a, h = p && p.d;
      p && (s /= h, i /= m, c /= m, d /= h, l = s + d, u = i + c);
    }
    return {
      top: s,
      left: i,
      bottom: l,
      right: u,
      width: c,
      height: d
    };
  }
}
function lo(e, t, n) {
  for (var o = Ne(e, !0), r = ee(e)[t]; o; ) {
    var a = ee(o)[n], s = void 0;
    if (n === "top" || n === "left" ? s = r >= a : s = r <= a, !s)
      return o;
    if (o === xe())
      break;
    o = Ne(o, !1);
  }
  return !1;
}
function Je(e, t, n, o) {
  for (var r = 0, a = 0, s = e.children; a < s.length; ) {
    if (s[a].style.display !== "none" && s[a] !== $.ghost && (o || s[a] !== $.dragged) && Se(s[a], n.draggable, e, !1)) {
      if (r === t)
        return s[a];
      r++;
    }
    a++;
  }
  return null;
}
function Pn(e, t) {
  for (var n = e.lastElementChild; n && (n === $.ghost || E(n, "display") === "none" || t && !qt(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function we(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== $.clone && (!t || qt(e, t)) && n++;
  return n;
}
function uo(e) {
  var t = 0, n = 0, o = xe();
  if (e)
    do {
      var r = Ke(e), a = r.a, s = r.d;
      t += e.scrollLeft * a, n += e.scrollTop * s;
    } while (e !== o && (e = e.parentNode));
  return [t, n];
}
function ps(e, t) {
  for (var n in e)
    if (!!e.hasOwnProperty(n)) {
      for (var o in t)
        if (t.hasOwnProperty(o) && t[o] === e[n][o])
          return Number(n);
    }
  return -1;
}
function Ne(e, t) {
  if (!e || !e.getBoundingClientRect)
    return xe();
  var n = e, o = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var r = E(n);
      if (n.clientWidth < n.scrollWidth && (r.overflowX == "auto" || r.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (r.overflowY == "auto" || r.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body)
          return xe();
        if (o || t)
          return n;
        o = !0;
      }
    }
  while (n = n.parentNode);
  return xe();
}
function ms(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function Gt(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var ut;
function Ko(e, t) {
  return function() {
    if (!ut) {
      var n = arguments, o = this;
      n.length === 1 ? e.call(o, n[0]) : e.apply(o, n), ut = setTimeout(function() {
        ut = void 0;
      }, t);
    }
  };
}
function hs() {
  clearTimeout(ut), ut = void 0;
}
function Zo(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function Qo(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
var me = "Sortable" + new Date().getTime();
function vs() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var o = [].slice.call(this.el.children);
        o.forEach(function(r) {
          if (!(E(r, "display") === "none" || r === $.ghost)) {
            e.push({
              target: r,
              rect: ee(r)
            });
            var a = Ee({}, e[e.length - 1].rect);
            if (r.thisAnimationDuration) {
              var s = Ke(r, !0);
              s && (a.top -= s.f, a.left -= s.e);
            }
            r.fromRect = a;
          }
        });
      }
    },
    addAnimationState: function(o) {
      e.push(o);
    },
    removeAnimationState: function(o) {
      e.splice(ps(e, {
        target: o
      }), 1);
    },
    animateAll: function(o) {
      var r = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof o == "function" && o();
        return;
      }
      var a = !1, s = 0;
      e.forEach(function(i) {
        var l = 0, u = i.target, d = u.fromRect, c = ee(u), f = u.prevFromRect, p = u.prevToRect, m = i.rect, h = Ke(u, !0);
        h && (c.top -= h.f, c.left -= h.e), u.toRect = c, u.thisAnimationDuration && Gt(f, c) && !Gt(d, c) && (m.top - c.top) / (m.left - c.left) === (d.top - c.top) / (d.left - c.left) && (l = ws(m, f, p, r.options)), Gt(c, d) || (u.prevFromRect = d, u.prevToRect = c, l || (l = r.options.animation), r.animate(u, m, c, l)), l && (a = !0, s = Math.max(s, l), clearTimeout(u.animationResetTimer), u.animationResetTimer = setTimeout(function() {
          u.animationTime = 0, u.prevFromRect = null, u.fromRect = null, u.prevToRect = null, u.thisAnimationDuration = null;
        }, l), u.thisAnimationDuration = l);
      }), clearTimeout(t), a ? t = setTimeout(function() {
        typeof o == "function" && o();
      }, s) : typeof o == "function" && o(), e = [];
    },
    animate: function(o, r, a, s) {
      if (s) {
        E(o, "transition", ""), E(o, "transform", "");
        var i = Ke(this.el), l = i && i.a, u = i && i.d, d = (r.left - a.left) / (l || 1), c = (r.top - a.top) / (u || 1);
        o.animatingX = !!d, o.animatingY = !!c, E(o, "transform", "translate3d(" + d + "px," + c + "px,0)"), this.forRepaintDummy = gs(o), E(o, "transition", "transform " + s + "ms" + (this.options.easing ? " " + this.options.easing : "")), E(o, "transform", "translate3d(0,0,0)"), typeof o.animated == "number" && clearTimeout(o.animated), o.animated = setTimeout(function() {
          E(o, "transition", ""), E(o, "transform", ""), o.animated = !1, o.animatingX = !1, o.animatingY = !1;
        }, s);
      }
    }
  };
}
function gs(e) {
  return e.offsetWidth;
}
function ws(e, t, n, o) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * o.animation;
}
var Ye = [], Kt = {
  initializeByDefault: !0
}, ht = {
  mount: function(t) {
    for (var n in Kt)
      Kt.hasOwnProperty(n) && !(n in t) && (t[n] = Kt[n]);
    Ye.forEach(function(o) {
      if (o.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), Ye.push(t);
  },
  pluginEvent: function(t, n, o) {
    var r = this;
    this.eventCanceled = !1, o.cancel = function() {
      r.eventCanceled = !0;
    };
    var a = t + "Global";
    Ye.forEach(function(s) {
      !n[s.pluginName] || (n[s.pluginName][a] && n[s.pluginName][a](Ee({
        sortable: n
      }, o)), n.options[s.pluginName] && n[s.pluginName][t] && n[s.pluginName][t](Ee({
        sortable: n
      }, o)));
    });
  },
  initializePlugins: function(t, n, o, r) {
    Ye.forEach(function(i) {
      var l = i.pluginName;
      if (!(!t.options[l] && !i.initializeByDefault)) {
        var u = new i(t, n, t.options);
        u.sortable = t, u.options = t.options, t[l] = u, ke(o, u.defaults);
      }
    });
    for (var a in t.options)
      if (!!t.options.hasOwnProperty(a)) {
        var s = this.modifyOption(t, a, t.options[a]);
        typeof s < "u" && (t.options[a] = s);
      }
  },
  getEventProperties: function(t, n) {
    var o = {};
    return Ye.forEach(function(r) {
      typeof r.eventProperties == "function" && ke(o, r.eventProperties.call(n[r.pluginName], t));
    }), o;
  },
  modifyOption: function(t, n, o) {
    var r;
    return Ye.forEach(function(a) {
      !t[a.pluginName] || a.optionListeners && typeof a.optionListeners[n] == "function" && (r = a.optionListeners[n].call(t[a.pluginName], o));
    }), r;
  }
};
function _s(e) {
  var t = e.sortable, n = e.rootEl, o = e.name, r = e.targetEl, a = e.cloneEl, s = e.toEl, i = e.fromEl, l = e.oldIndex, u = e.newIndex, d = e.oldDraggableIndex, c = e.newDraggableIndex, f = e.originalEvent, p = e.putSortable, m = e.extraEventProperties;
  if (t = t || n && n[me], !!t) {
    var h, _ = t.options, P = "on" + o.charAt(0).toUpperCase() + o.substr(1);
    window.CustomEvent && !Ce && !mt ? h = new CustomEvent(o, {
      bubbles: !0,
      cancelable: !0
    }) : (h = document.createEvent("Event"), h.initEvent(o, !0, !0)), h.to = s || n, h.from = i || n, h.item = r || n, h.clone = a, h.oldIndex = l, h.newIndex = u, h.oldDraggableIndex = d, h.newDraggableIndex = c, h.originalEvent = f, h.pullMode = p ? p.lastPutMode : void 0;
    var C = Ee(Ee({}, m), ht.getEventProperties(o, t));
    for (var D in C)
      h[D] = C[D];
    n && n.dispatchEvent(h), _[P] && _[P].call(t, h);
  }
}
var bs = ["evt"], se = function(t, n) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = o.evt, a = cs(o, bs);
  ht.pluginEvent.bind($)(t, n, Ee({
    dragEl: g,
    parentEl: G,
    ghostEl: k,
    rootEl: U,
    nextEl: ze,
    lastDownEl: yt,
    cloneEl: W,
    cloneHidden: qe,
    dragStarted: rt,
    putSortable: oe,
    activeSortable: $.active,
    originalEvent: r,
    oldIndex: Ge,
    oldDraggableIndex: ct,
    newIndex: fe,
    newDraggableIndex: Ae,
    hideGhostForTarget: nr,
    unhideGhostForTarget: or,
    cloneNowHidden: function() {
      qe = !0;
    },
    cloneNowShown: function() {
      qe = !1;
    },
    dispatchSortableEvent: function(i) {
      ae({
        sortable: n,
        name: i,
        originalEvent: r
      });
    }
  }, a));
};
function ae(e) {
  _s(Ee({
    putSortable: oe,
    cloneEl: W,
    targetEl: g,
    rootEl: U,
    oldIndex: Ge,
    oldDraggableIndex: ct,
    newIndex: fe,
    newDraggableIndex: Ae
  }, e));
}
var g, G, k, U, ze, yt, W, qe, Ge, fe, ct, Ae, vt, oe, Xe = !1, Mt = !1, Nt = [], Be, ye, Zt, Qt, co, fo, rt, We, dt, ft = !1, gt = !1, St, ie, Jt = [], pn = !1, Rt = [], Ht = typeof document < "u", wt = Yo, po = mt || Ce ? "cssFloat" : "float", ys = Ht && !Wo && !Yo && "draggable" in document.createElement("div"), Jo = function() {
  if (!!Ht) {
    if (Ce)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), er = function(t, n) {
  var o = E(t), r = parseInt(o.width) - parseInt(o.paddingLeft) - parseInt(o.paddingRight) - parseInt(o.borderLeftWidth) - parseInt(o.borderRightWidth), a = Je(t, 0, n), s = Je(t, 1, n), i = a && E(a), l = s && E(s), u = i && parseInt(i.marginLeft) + parseInt(i.marginRight) + ee(a).width, d = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + ee(s).width;
  if (o.display === "flex")
    return o.flexDirection === "column" || o.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (o.display === "grid")
    return o.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (a && i.float && i.float !== "none") {
    var c = i.float === "left" ? "left" : "right";
    return s && (l.clear === "both" || l.clear === c) ? "vertical" : "horizontal";
  }
  return a && (i.display === "block" || i.display === "flex" || i.display === "table" || i.display === "grid" || u >= r && o[po] === "none" || s && o[po] === "none" && u + d > r) ? "vertical" : "horizontal";
}, Ss = function(t, n, o) {
  var r = o ? t.left : t.top, a = o ? t.right : t.bottom, s = o ? t.width : t.height, i = o ? n.left : n.top, l = o ? n.right : n.bottom, u = o ? n.width : n.height;
  return r === i || a === l || r + s / 2 === i + u / 2;
}, xs = function(t, n) {
  var o;
  return Nt.some(function(r) {
    var a = r[me].options.emptyInsertThreshold;
    if (!(!a || Pn(r))) {
      var s = ee(r), i = t >= s.left - a && t <= s.right + a, l = n >= s.top - a && n <= s.bottom + a;
      if (i && l)
        return o = r;
    }
  }), o;
}, tr = function(t) {
  function n(a, s) {
    return function(i, l, u, d) {
      var c = i.options.group.name && l.options.group.name && i.options.group.name === l.options.group.name;
      if (a == null && (s || c))
        return !0;
      if (a == null || a === !1)
        return !1;
      if (s && a === "clone")
        return a;
      if (typeof a == "function")
        return n(a(i, l, u, d), s)(i, l, u, d);
      var f = (s ? i : l).options.group.name;
      return a === !0 || typeof a == "string" && a === f || a.join && a.indexOf(f) > -1;
    };
  }
  var o = {}, r = t.group;
  (!r || bt(r) != "object") && (r = {
    name: r
  }), o.name = r.name, o.checkPull = n(r.pull, !0), o.checkPut = n(r.put), o.revertClone = r.revertClone, t.group = o;
}, nr = function() {
  !Jo && k && E(k, "display", "none");
}, or = function() {
  !Jo && k && E(k, "display", "");
};
Ht && !Wo && document.addEventListener("click", function(e) {
  if (Mt)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), Mt = !1, !1;
}, !0);
var Le = function(t) {
  if (g) {
    t = t.touches ? t.touches[0] : t;
    var n = xs(t.clientX, t.clientY);
    if (n) {
      var o = {};
      for (var r in t)
        t.hasOwnProperty(r) && (o[r] = t[r]);
      o.target = o.rootEl = n, o.preventDefault = void 0, o.stopPropagation = void 0, n[me]._onDragOver(o);
    }
  }
}, Is = function(t) {
  g && g.parentNode[me]._isOutsideThisEl(t.target);
};
function $(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = ke({}, t), e[me] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: !1,
    invertedSwapThreshold: null,
    removeCloneOnHide: !0,
    direction: function() {
      return er(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(s, i) {
      s.setData("Text", i.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: $.supportPointer !== !1 && "PointerEvent" in window && !lt,
    emptyInsertThreshold: 5
  };
  ht.initializePlugins(this, e, n);
  for (var o in n)
    !(o in t) && (t[o] = n[o]);
  tr(t);
  for (var r in this)
    r.charAt(0) === "_" && typeof this[r] == "function" && (this[r] = this[r].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : ys, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? N(e, "pointerdown", this._onTapStart) : (N(e, "mousedown", this._onTapStart), N(e, "touchstart", this._onTapStart)), this.nativeDraggable && (N(e, "dragover", this), N(e, "dragenter", this)), Nt.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), ke(this, vs());
}
$.prototype = {
  constructor: $,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (We = null);
  },
  _getDirection: function(t, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, n, g) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (!!t.cancelable) {
      var n = this, o = this.el, r = this.options, a = r.preventOnFilter, s = t.type, i = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, l = (i || t).target, u = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || l, d = r.filter;
      if (Ps(o), !g && !(/mousedown|pointerdown/.test(s) && t.button !== 0 || r.disabled) && !u.isContentEditable && !(!this.nativeDraggable && lt && l && l.tagName.toUpperCase() === "SELECT") && (l = Se(l, r.draggable, o, !1), !(l && l.animated) && yt !== l)) {
        if (Ge = we(l), ct = we(l, r.draggable), typeof d == "function") {
          if (d.call(this, t, l, this)) {
            ae({
              sortable: n,
              rootEl: u,
              name: "filter",
              targetEl: l,
              toEl: o,
              fromEl: o
            }), se("filter", n, {
              evt: t
            }), a && t.cancelable && t.preventDefault();
            return;
          }
        } else if (d && (d = d.split(",").some(function(c) {
          if (c = Se(u, c.trim(), o, !1), c)
            return ae({
              sortable: n,
              rootEl: c,
              name: "filter",
              targetEl: l,
              fromEl: o,
              toEl: o
            }), se("filter", n, {
              evt: t
            }), !0;
        }), d)) {
          a && t.cancelable && t.preventDefault();
          return;
        }
        r.handle && !Se(u, r.handle, o, !1) || this._prepareDragStart(t, i, l);
      }
    }
  },
  _prepareDragStart: function(t, n, o) {
    var r = this, a = r.el, s = r.options, i = a.ownerDocument, l;
    if (o && !g && o.parentNode === a) {
      var u = ee(o);
      if (U = a, g = o, G = g.parentNode, ze = g.nextSibling, yt = o, vt = s.group, $.dragged = g, Be = {
        target: g,
        clientX: (n || t).clientX,
        clientY: (n || t).clientY
      }, co = Be.clientX - u.left, fo = Be.clientY - u.top, this._lastX = (n || t).clientX, this._lastY = (n || t).clientY, g.style["will-change"] = "all", l = function() {
        if (se("delayEnded", r, {
          evt: t
        }), $.eventCanceled) {
          r._onDrop();
          return;
        }
        r._disableDelayedDragEvents(), !ao && r.nativeDraggable && (g.draggable = !0), r._triggerDragStart(t, n), ae({
          sortable: r,
          name: "choose",
          originalEvent: t
        }), de(g, s.chosenClass, !0);
      }, s.ignore.split(",").forEach(function(d) {
        Go(g, d.trim(), en);
      }), N(i, "dragover", Le), N(i, "mousemove", Le), N(i, "touchmove", Le), N(i, "mouseup", r._onDrop), N(i, "touchend", r._onDrop), N(i, "touchcancel", r._onDrop), ao && this.nativeDraggable && (this.options.touchStartThreshold = 4, g.draggable = !0), se("delayStart", this, {
        evt: t
      }), s.delay && (!s.delayOnTouchOnly || n) && (!this.nativeDraggable || !(mt || Ce))) {
        if ($.eventCanceled) {
          this._onDrop();
          return;
        }
        N(i, "mouseup", r._disableDelayedDrag), N(i, "touchend", r._disableDelayedDrag), N(i, "touchcancel", r._disableDelayedDrag), N(i, "mousemove", r._delayedDragTouchMoveHandler), N(i, "touchmove", r._delayedDragTouchMoveHandler), s.supportPointer && N(i, "pointermove", r._delayedDragTouchMoveHandler), r._dragStartTimer = setTimeout(l, s.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var n = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    g && en(g), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    q(t, "mouseup", this._disableDelayedDrag), q(t, "touchend", this._disableDelayedDrag), q(t, "touchcancel", this._disableDelayedDrag), q(t, "mousemove", this._delayedDragTouchMoveHandler), q(t, "touchmove", this._delayedDragTouchMoveHandler), q(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, n) {
    n = n || t.pointerType == "touch" && t, !this.nativeDraggable || n ? this.options.supportPointer ? N(document, "pointermove", this._onTouchMove) : n ? N(document, "touchmove", this._onTouchMove) : N(document, "mousemove", this._onTouchMove) : (N(g, "dragend", this), N(U, "dragstart", this._onDragStart));
    try {
      document.selection ? xt(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, n) {
    if (Xe = !1, U && g) {
      se("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && N(document, "dragover", Is);
      var o = this.options;
      !t && de(g, o.dragClass, !1), de(g, o.ghostClass, !0), $.active = this, t && this._appendGhost(), ae({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (ye) {
      this._lastX = ye.clientX, this._lastY = ye.clientY, nr();
      for (var t = document.elementFromPoint(ye.clientX, ye.clientY), n = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(ye.clientX, ye.clientY), t !== n); )
        n = t;
      if (g.parentNode[me]._isOutsideThisEl(t), n)
        do {
          if (n[me]) {
            var o = void 0;
            if (o = n[me]._onDragOver({
              clientX: ye.clientX,
              clientY: ye.clientY,
              target: t,
              rootEl: n
            }), o && !this.options.dragoverBubble)
              break;
          }
          t = n;
        } while (n = n.parentNode);
      or();
    }
  },
  _onTouchMove: function(t) {
    if (Be) {
      var n = this.options, o = n.fallbackTolerance, r = n.fallbackOffset, a = t.touches ? t.touches[0] : t, s = k && Ke(k, !0), i = k && s && s.a, l = k && s && s.d, u = wt && ie && uo(ie), d = (a.clientX - Be.clientX + r.x) / (i || 1) + (u ? u[0] - Jt[0] : 0) / (i || 1), c = (a.clientY - Be.clientY + r.y) / (l || 1) + (u ? u[1] - Jt[1] : 0) / (l || 1);
      if (!$.active && !Xe) {
        if (o && Math.max(Math.abs(a.clientX - this._lastX), Math.abs(a.clientY - this._lastY)) < o)
          return;
        this._onDragStart(t, !0);
      }
      if (k) {
        s ? (s.e += d - (Zt || 0), s.f += c - (Qt || 0)) : s = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: d,
          f: c
        };
        var f = "matrix(".concat(s.a, ",").concat(s.b, ",").concat(s.c, ",").concat(s.d, ",").concat(s.e, ",").concat(s.f, ")");
        E(k, "webkitTransform", f), E(k, "mozTransform", f), E(k, "msTransform", f), E(k, "transform", f), Zt = d, Qt = c, ye = a;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!k) {
      var t = this.options.fallbackOnBody ? document.body : U, n = ee(g, !0, wt, !0, t), o = this.options;
      if (wt) {
        for (ie = t; E(ie, "position") === "static" && E(ie, "transform") === "none" && ie !== document; )
          ie = ie.parentNode;
        ie !== document.body && ie !== document.documentElement ? (ie === document && (ie = xe()), n.top += ie.scrollTop, n.left += ie.scrollLeft) : ie = xe(), Jt = uo(ie);
      }
      k = g.cloneNode(!0), de(k, o.ghostClass, !1), de(k, o.fallbackClass, !0), de(k, o.dragClass, !0), E(k, "transition", ""), E(k, "transform", ""), E(k, "box-sizing", "border-box"), E(k, "margin", 0), E(k, "top", n.top), E(k, "left", n.left), E(k, "width", n.width), E(k, "height", n.height), E(k, "opacity", "0.8"), E(k, "position", wt ? "absolute" : "fixed"), E(k, "zIndex", "100000"), E(k, "pointerEvents", "none"), $.ghost = k, t.appendChild(k), E(k, "transform-origin", co / parseInt(k.style.width) * 100 + "% " + fo / parseInt(k.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, n) {
    var o = this, r = t.dataTransfer, a = o.options;
    if (se("dragStart", this, {
      evt: t
    }), $.eventCanceled) {
      this._onDrop();
      return;
    }
    se("setupClone", this), $.eventCanceled || (W = Qo(g), W.removeAttribute("id"), W.draggable = !1, W.style["will-change"] = "", this._hideClone(), de(W, this.options.chosenClass, !1), $.clone = W), o.cloneId = xt(function() {
      se("clone", o), !$.eventCanceled && (o.options.removeCloneOnHide || U.insertBefore(W, g), o._hideClone(), ae({
        sortable: o,
        name: "clone"
      }));
    }), !n && de(g, a.dragClass, !0), n ? (Mt = !0, o._loopId = setInterval(o._emulateDragOver, 50)) : (q(document, "mouseup", o._onDrop), q(document, "touchend", o._onDrop), q(document, "touchcancel", o._onDrop), r && (r.effectAllowed = "move", a.setData && a.setData.call(o, r, g)), N(document, "drop", o), E(g, "transform", "translateZ(0)")), Xe = !0, o._dragStartId = xt(o._dragStarted.bind(o, n, t)), N(document, "selectstart", o), rt = !0, lt && E(document.body, "user-select", "none");
  },
  _onDragOver: function(t) {
    var n = this.el, o = t.target, r, a, s, i = this.options, l = i.group, u = $.active, d = vt === l, c = i.sort, f = oe || u, p, m = this, h = !1;
    if (pn)
      return;
    function _(be, ce) {
      se(be, m, Ee({
        evt: t,
        isOwner: d,
        axis: p ? "vertical" : "horizontal",
        revert: s,
        dragRect: r,
        targetRect: a,
        canSort: c,
        fromSortable: f,
        target: o,
        completed: C,
        onMove: function(Nn, br) {
          return _t(U, n, g, r, Nn, ee(Nn), t, br);
        },
        changed: D
      }, ce));
    }
    function P() {
      _("dragOverAnimationCapture"), m.captureAnimationState(), m !== f && f.captureAnimationState();
    }
    function C(be) {
      return _("dragOverCompleted", {
        insertion: be
      }), be && (d ? u._hideClone() : u._showClone(m), m !== f && (de(g, oe ? oe.options.ghostClass : u.options.ghostClass, !1), de(g, i.ghostClass, !0)), oe !== m && m !== $.active ? oe = m : m === $.active && oe && (oe = null), f === m && (m._ignoreWhileAnimating = o), m.animateAll(function() {
        _("dragOverAnimationComplete"), m._ignoreWhileAnimating = null;
      }), m !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (o === g && !g.animated || o === n && !o.animated) && (We = null), !i.dragoverBubble && !t.rootEl && o !== document && (g.parentNode[me]._isOutsideThisEl(t.target), !be && Le(t)), !i.dragoverBubble && t.stopPropagation && t.stopPropagation(), h = !0;
    }
    function D() {
      fe = we(g), Ae = we(g, i.draggable), ae({
        sortable: m,
        name: "change",
        toEl: n,
        newIndex: fe,
        newDraggableIndex: Ae,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), o = Se(o, i.draggable, n, !0), _("dragOver"), $.eventCanceled)
      return h;
    if (g.contains(t.target) || o.animated && o.animatingX && o.animatingY || m._ignoreWhileAnimating === o)
      return C(!1);
    if (Mt = !1, u && !i.disabled && (d ? c || (s = G !== U) : oe === this || (this.lastPutMode = vt.checkPull(this, u, g, t)) && l.checkPut(this, u, g, t))) {
      if (p = this._getDirection(t, o) === "vertical", r = ee(g), _("dragOverValid"), $.eventCanceled)
        return h;
      if (s)
        return G = U, P(), this._hideClone(), _("revert"), $.eventCanceled || (ze ? U.insertBefore(g, ze) : U.appendChild(g)), C(!0);
      var z = Pn(n, i.draggable);
      if (!z || Os(t, p, this) && !z.animated) {
        if (z === g)
          return C(!1);
        if (z && n === t.target && (o = z), o && (a = ee(o)), _t(U, n, g, r, o, a, t, !!o) !== !1)
          return P(), z && z.nextSibling ? n.insertBefore(g, z.nextSibling) : n.appendChild(g), G = n, D(), C(!0);
      } else if (z && Ts(t, p, this)) {
        var H = Je(n, 0, i, !0);
        if (H === g)
          return C(!1);
        if (o = H, a = ee(o), _t(U, n, g, r, o, a, t, !1) !== !1)
          return P(), n.insertBefore(g, H), G = n, D(), C(!0);
      } else if (o.parentNode === n) {
        a = ee(o);
        var S = 0, ge, $e = g.parentNode !== n, te = !Ss(g.animated && g.toRect || r, o.animated && o.toRect || a, p), R = p ? "top" : "left", A = lo(o, "top", "top") || lo(g, "top", "top"), V = A ? A.scrollTop : void 0;
        We !== o && (ge = a[R], ft = !1, gt = !te && i.invertSwap || $e), S = ks(t, o, a, p, te ? 1 : i.swapThreshold, i.invertedSwapThreshold == null ? i.swapThreshold : i.invertedSwapThreshold, gt, We === o);
        var F;
        if (S !== 0) {
          var T = we(g);
          do
            T -= S, F = G.children[T];
          while (F && (E(F, "display") === "none" || F === k));
        }
        if (S === 0 || F === o)
          return C(!1);
        We = o, dt = S;
        var ne = o.nextElementSibling, Y = !1;
        Y = S === 1;
        var Pe = _t(U, n, g, r, o, a, t, Y);
        if (Pe !== !1)
          return (Pe === 1 || Pe === -1) && (Y = Pe === 1), pn = !0, setTimeout($s, 30), P(), Y && !ne ? n.appendChild(g) : o.parentNode.insertBefore(g, Y ? ne : o), A && Zo(A, 0, V - A.scrollTop), G = g.parentNode, ge !== void 0 && !gt && (St = Math.abs(ge - ee(o)[R])), D(), C(!0);
      }
      if (n.contains(g))
        return C(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    q(document, "mousemove", this._onTouchMove), q(document, "touchmove", this._onTouchMove), q(document, "pointermove", this._onTouchMove), q(document, "dragover", Le), q(document, "mousemove", Le), q(document, "touchmove", Le);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    q(t, "mouseup", this._onDrop), q(t, "touchend", this._onDrop), q(t, "pointerup", this._onDrop), q(t, "touchcancel", this._onDrop), q(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var n = this.el, o = this.options;
    if (fe = we(g), Ae = we(g, o.draggable), se("drop", this, {
      evt: t
    }), G = g && g.parentNode, fe = we(g), Ae = we(g, o.draggable), $.eventCanceled) {
      this._nulling();
      return;
    }
    Xe = !1, gt = !1, ft = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), mn(this.cloneId), mn(this._dragStartId), this.nativeDraggable && (q(document, "drop", this), q(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), lt && E(document.body, "user-select", ""), E(g, "transform", ""), t && (rt && (t.cancelable && t.preventDefault(), !o.dropBubble && t.stopPropagation()), k && k.parentNode && k.parentNode.removeChild(k), (U === G || oe && oe.lastPutMode !== "clone") && W && W.parentNode && W.parentNode.removeChild(W), g && (this.nativeDraggable && q(g, "dragend", this), en(g), g.style["will-change"] = "", rt && !Xe && de(g, oe ? oe.options.ghostClass : this.options.ghostClass, !1), de(g, this.options.chosenClass, !1), ae({
      sortable: this,
      name: "unchoose",
      toEl: G,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), U !== G ? (fe >= 0 && (ae({
      rootEl: G,
      name: "add",
      toEl: G,
      fromEl: U,
      originalEvent: t
    }), ae({
      sortable: this,
      name: "remove",
      toEl: G,
      originalEvent: t
    }), ae({
      rootEl: G,
      name: "sort",
      toEl: G,
      fromEl: U,
      originalEvent: t
    }), ae({
      sortable: this,
      name: "sort",
      toEl: G,
      originalEvent: t
    })), oe && oe.save()) : fe !== Ge && fe >= 0 && (ae({
      sortable: this,
      name: "update",
      toEl: G,
      originalEvent: t
    }), ae({
      sortable: this,
      name: "sort",
      toEl: G,
      originalEvent: t
    })), $.active && ((fe == null || fe === -1) && (fe = Ge, Ae = ct), ae({
      sortable: this,
      name: "end",
      toEl: G,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    se("nulling", this), U = g = G = k = ze = W = yt = qe = Be = ye = rt = fe = Ae = Ge = ct = We = dt = oe = vt = $.dragged = $.ghost = $.clone = $.active = null, Rt.forEach(function(t) {
      t.checked = !0;
    }), Rt.length = Zt = Qt = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        g && (this._onDragOver(t), Es(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  toArray: function() {
    for (var t = [], n, o = this.el.children, r = 0, a = o.length, s = this.options; r < a; r++)
      n = o[r], Se(n, s.draggable, this.el, !1) && t.push(n.getAttribute(s.dataIdAttr) || Ds(n));
    return t;
  },
  sort: function(t, n) {
    var o = {}, r = this.el;
    this.toArray().forEach(function(a, s) {
      var i = r.children[s];
      Se(i, this.options.draggable, r, !1) && (o[a] = i);
    }, this), n && this.captureAnimationState(), t.forEach(function(a) {
      o[a] && (r.removeChild(o[a]), r.appendChild(o[a]));
    }), n && this.animateAll();
  },
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  closest: function(t, n) {
    return Se(t, n || this.options.draggable, this.el, !1);
  },
  option: function(t, n) {
    var o = this.options;
    if (n === void 0)
      return o[t];
    var r = ht.modifyOption(this, t, n);
    typeof r < "u" ? o[t] = r : o[t] = n, t === "group" && tr(o);
  },
  destroy: function() {
    se("destroy", this);
    var t = this.el;
    t[me] = null, q(t, "mousedown", this._onTapStart), q(t, "touchstart", this._onTapStart), q(t, "pointerdown", this._onTapStart), this.nativeDraggable && (q(t, "dragover", this), q(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Nt.splice(Nt.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!qe) {
      if (se("hideClone", this), $.eventCanceled)
        return;
      E(W, "display", "none"), this.options.removeCloneOnHide && W.parentNode && W.parentNode.removeChild(W), qe = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (qe) {
      if (se("showClone", this), $.eventCanceled)
        return;
      g.parentNode == U && !this.options.group.revertClone ? U.insertBefore(W, g) : ze ? U.insertBefore(W, ze) : U.appendChild(W), this.options.group.revertClone && this.animate(g, W), E(W, "display", ""), qe = !1;
    }
  }
};
function Es(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function _t(e, t, n, o, r, a, s, i) {
  var l, u = e[me], d = u.options.onMove, c;
  return window.CustomEvent && !Ce && !mt ? l = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (l = document.createEvent("Event"), l.initEvent("move", !0, !0)), l.to = t, l.from = e, l.dragged = n, l.draggedRect = o, l.related = r || t, l.relatedRect = a || ee(t), l.willInsertAfter = i, l.originalEvent = s, e.dispatchEvent(l), d && (c = d.call(u, l, s)), c;
}
function en(e) {
  e.draggable = !1;
}
function $s() {
  pn = !1;
}
function Ts(e, t, n) {
  var o = ee(Je(n.el, 0, n.options, !0)), r = 10;
  return t ? e.clientX < o.left - r || e.clientY < o.top && e.clientX < o.right : e.clientY < o.top - r || e.clientY < o.bottom && e.clientX < o.left;
}
function Os(e, t, n) {
  var o = ee(Pn(n.el, n.options.draggable)), r = 10;
  return t ? e.clientX > o.right + r || e.clientX <= o.right && e.clientY > o.bottom && e.clientX >= o.left : e.clientX > o.right && e.clientY > o.top || e.clientX <= o.right && e.clientY > o.bottom + r;
}
function ks(e, t, n, o, r, a, s, i) {
  var l = o ? e.clientY : e.clientX, u = o ? n.height : n.width, d = o ? n.top : n.left, c = o ? n.bottom : n.right, f = !1;
  if (!s) {
    if (i && St < u * r) {
      if (!ft && (dt === 1 ? l > d + u * a / 2 : l < c - u * a / 2) && (ft = !0), ft)
        f = !0;
      else if (dt === 1 ? l < d + St : l > c - St)
        return -dt;
    } else if (l > d + u * (1 - r) / 2 && l < c - u * (1 - r) / 2)
      return Cs(t);
  }
  return f = f || s, f && (l < d + u * a / 2 || l > c - u * a / 2) ? l > d + u / 2 ? 1 : -1 : 0;
}
function Cs(e) {
  return we(g) < we(e) ? 1 : -1;
}
function Ds(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, o = 0; n--; )
    o += t.charCodeAt(n);
  return o.toString(36);
}
function Ps(e) {
  Rt.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var o = t[n];
    o.checked && Rt.push(o);
  }
}
function xt(e) {
  return setTimeout(e, 0);
}
function mn(e) {
  return clearTimeout(e);
}
Ht && N(document, "touchmove", function(e) {
  ($.active || Xe) && e.cancelable && e.preventDefault();
});
$.utils = {
  on: N,
  off: q,
  css: E,
  find: Go,
  is: function(t, n) {
    return !!Se(t, n, t, !1);
  },
  extend: ms,
  throttle: Ko,
  closest: Se,
  toggleClass: de,
  clone: Qo,
  index: we,
  nextTick: xt,
  cancelNextTick: mn,
  detectDirection: er,
  getChild: Je
};
$.get = function(e) {
  return e[me];
};
$.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(o) {
    if (!o.prototype || !o.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(o));
    o.utils && ($.utils = Ee(Ee({}, $.utils), o.utils)), ht.mount(o);
  });
};
$.create = function(e, t) {
  return new $(e, t);
};
$.version = ds;
var K = [], it, hn, vn = !1, tn, nn, jt, at;
function As() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(n) {
      var o = n.originalEvent;
      this.sortable.nativeDraggable ? N(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? N(document, "pointermove", this._handleFallbackAutoScroll) : o.touches ? N(document, "touchmove", this._handleFallbackAutoScroll) : N(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var o = n.originalEvent;
      !this.options.dragOverBubble && !o.rootEl && this._handleAutoScroll(o);
    },
    drop: function() {
      this.sortable.nativeDraggable ? q(document, "dragover", this._handleAutoScroll) : (q(document, "pointermove", this._handleFallbackAutoScroll), q(document, "touchmove", this._handleFallbackAutoScroll), q(document, "mousemove", this._handleFallbackAutoScroll)), mo(), It(), hs();
    },
    nulling: function() {
      jt = hn = it = vn = at = tn = nn = null, K.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, o) {
      var r = this, a = (n.touches ? n.touches[0] : n).clientX, s = (n.touches ? n.touches[0] : n).clientY, i = document.elementFromPoint(a, s);
      if (jt = n, o || this.options.forceAutoScrollFallback || mt || Ce || lt) {
        on(n, this.options, i, o);
        var l = Ne(i, !0);
        vn && (!at || a !== tn || s !== nn) && (at && mo(), at = setInterval(function() {
          var u = Ne(document.elementFromPoint(a, s), !0);
          u !== l && (l = u, It()), on(n, r.options, u, o);
        }, 10), tn = a, nn = s);
      } else {
        if (!this.options.bubbleScroll || Ne(i, !0) === xe()) {
          It();
          return;
        }
        on(n, this.options, Ne(i, !1), !1);
      }
    }
  }, ke(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function It() {
  K.forEach(function(e) {
    clearInterval(e.pid);
  }), K = [];
}
function mo() {
  clearInterval(at);
}
var on = Ko(function(e, t, n, o) {
  if (!!t.scroll) {
    var r = (e.touches ? e.touches[0] : e).clientX, a = (e.touches ? e.touches[0] : e).clientY, s = t.scrollSensitivity, i = t.scrollSpeed, l = xe(), u = !1, d;
    hn !== n && (hn = n, It(), it = t.scroll, d = t.scrollFn, it === !0 && (it = Ne(n, !0)));
    var c = 0, f = it;
    do {
      var p = f, m = ee(p), h = m.top, _ = m.bottom, P = m.left, C = m.right, D = m.width, z = m.height, H = void 0, S = void 0, ge = p.scrollWidth, $e = p.scrollHeight, te = E(p), R = p.scrollLeft, A = p.scrollTop;
      p === l ? (H = D < ge && (te.overflowX === "auto" || te.overflowX === "scroll" || te.overflowX === "visible"), S = z < $e && (te.overflowY === "auto" || te.overflowY === "scroll" || te.overflowY === "visible")) : (H = D < ge && (te.overflowX === "auto" || te.overflowX === "scroll"), S = z < $e && (te.overflowY === "auto" || te.overflowY === "scroll"));
      var V = H && (Math.abs(C - r) <= s && R + D < ge) - (Math.abs(P - r) <= s && !!R), F = S && (Math.abs(_ - a) <= s && A + z < $e) - (Math.abs(h - a) <= s && !!A);
      if (!K[c])
        for (var T = 0; T <= c; T++)
          K[T] || (K[T] = {});
      (K[c].vx != V || K[c].vy != F || K[c].el !== p) && (K[c].el = p, K[c].vx = V, K[c].vy = F, clearInterval(K[c].pid), (V != 0 || F != 0) && (u = !0, K[c].pid = setInterval(function() {
        o && this.layer === 0 && $.active._onTouchMove(jt);
        var ne = K[this.layer].vy ? K[this.layer].vy * i : 0, Y = K[this.layer].vx ? K[this.layer].vx * i : 0;
        typeof d == "function" && d.call($.dragged.parentNode[me], Y, ne, e, jt, K[this.layer].el) !== "continue" || Zo(K[this.layer].el, Y, ne);
      }.bind({
        layer: c
      }), 24))), c++;
    } while (t.bubbleScroll && f !== l && (f = Ne(f, !1)));
    vn = u;
  }
}, 30), rr = function(t) {
  var n = t.originalEvent, o = t.putSortable, r = t.dragEl, a = t.activeSortable, s = t.dispatchSortableEvent, i = t.hideGhostForTarget, l = t.unhideGhostForTarget;
  if (!!n) {
    var u = o || a;
    i();
    var d = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, c = document.elementFromPoint(d.clientX, d.clientY);
    l(), u && !u.el.contains(c) && (s("spill"), this.onSpill({
      dragEl: r,
      putSortable: o
    }));
  }
};
function An() {
}
An.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var n = t.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(t) {
    var n = t.dragEl, o = t.putSortable;
    this.sortable.captureAnimationState(), o && o.captureAnimationState();
    var r = Je(this.sortable.el, this.startIndex, this.options);
    r ? this.sortable.el.insertBefore(n, r) : this.sortable.el.appendChild(n), this.sortable.animateAll(), o && o.animateAll();
  },
  drop: rr
};
ke(An, {
  pluginName: "revertOnSpill"
});
function qn() {
}
qn.prototype = {
  onSpill: function(t) {
    var n = t.dragEl, o = t.putSortable, r = o || this.sortable;
    r.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), r.animateAll();
  },
  drop: rr
};
ke(qn, {
  pluginName: "removeOnSpill"
});
$.mount(new As());
$.mount(qn, An);
const qs = /* @__PURE__ */ j({
  __name: "Sortable",
  props: {
    options: {
      type: Object,
      default: null,
      required: !1
    },
    list: {
      type: Array,
      default: [],
      required: !0
    },
    itemKey: {
      type: [String, Function],
      default: "",
      required: !0
    },
    tag: {
      type: String,
      default: "div",
      required: !1
    }
  },
  emits: ["choose", "unchoose", "start", "end", "add", "update", "sort", "remove", "filter", "move", "clone", "change"],
  setup(e, { emit: t }) {
    const n = e, o = y(null), r = y(null), a = M(() => typeof n.itemKey == "string" ? (s) => s[n.itemKey] : n.itemKey);
    return re(o, (s) => {
      s && (r.value = new $(s, {
        ...n.options,
        onChoose: (i) => t("choose", i),
        onUnchoose: (i) => t("unchoose", i),
        onStart: (i) => t("start", i),
        onEnd: (i) => t("end", i),
        onAdd: (i) => t("add", i),
        onUpdate: (i) => t("update", i),
        onSort: (i) => t("sort", i),
        onRemove: (i) => t("remove", i),
        onFilter: (i) => t("filter", i),
        onMove: (i, l) => t("move", i, l),
        onClone: (i) => t("clone", i),
        onChange: (i) => t("change", i)
      }));
    }), re(() => n.options, (s) => {
      s && (r == null ? void 0 : r.value) && (r.value.options = { ...r.value.options, ...s });
    }), Bt(() => {
      r.value && (r.value.destroy(), o.value = null, r.value = null);
    }), (s, i) => (w(), B(xo(s.$props.tag), {
      ref_key: "containerRef",
      ref: o,
      class: le(s.$props.class)
    }, {
      default: O(() => [
        (w(!0), I(_e, null, $t(e.list, (l, u) => ue(s.$slots, "item", {
          key: v(a)(l),
          element: l,
          index: u
        })), 128))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Ms = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Ns = /* @__PURE__ */ b("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ b("path", { d: "M18.5 13.5c-3.17-4-6.17-6-9-6s-5.163 1-7 3" }),
  /* @__PURE__ */ b("path", { d: "M13.5 13.5h5v-5" })
], -1), Rs = [
  Ns
];
function js(e, t) {
  return w(), I("svg", Ms, Rs);
}
const Fs = { name: "system-uicons-redo", render: js }, Bs = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Ls = /* @__PURE__ */ b("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ b("path", { d: "M2.5 13.5c3.333-4 6.333-6 9-6s5 1 7 3" }),
  /* @__PURE__ */ b("path", { d: "M2.5 8.5v5h5" })
], -1), zs = [
  Ls
];
function Us(e, t) {
  return w(), I("svg", Bs, zs);
}
const Hs = { name: "system-uicons-undo", render: Us }, Vs = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Ys = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M10.5 3.5v2m5 0L14 7M5.5 5.5L7 7m3.5 10.5v-2m5 0L14 14m-8.5 1.5L7 14m-3.5-3.5h2m10 0h2"
}, null, -1), Ws = [
  Ys
];
function Xs(e, t) {
  return w(), I("svg", Vs, Ws);
}
const Gs = { name: "system-uicons-loader", render: Xs }, Ks = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Zs = /* @__PURE__ */ b("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ b("path", { d: "M10.5 5.5a5 5 0 0 1 4.802 6.399A2 2 0 1 1 16.5 15.5h-11a3 3 0 1 1 .1-5.998A5.002 5.002 0 0 1 10.5 5.5z" }),
  /* @__PURE__ */ b("path", { d: "m8.5 9.5l2-2l2 2m-2-2v6" })
], -1), Qs = [
  Zs
];
function Js(e, t) {
  return w(), I("svg", Ks, Qs);
}
const el = { name: "system-uicons-cloud-upload", render: Js }, tl = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 16 16",
  width: "1.2em",
  height: "1.2em"
}, nl = /* @__PURE__ */ b("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
}, null, -1), ol = [
  nl
];
function rl(e, t) {
  return w(), I("svg", tl, ol);
}
const il = { name: "bi-slash-lg", render: rl };
function Vt(e, t, ...n) {
  if (e in t) {
    let r = t[e];
    return typeof r == "function" ? r(...n) : r;
  }
  let o = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((r) => `"${r}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(o, Vt), o;
}
var gn = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(gn || {}), al = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(al || {});
function De({ visible: e = !0, features: t = 0, ourProps: n, theirProps: o, ...r }) {
  var a;
  let s = sl(o, n), i = Object.assign(r, { props: s });
  if (e || t & 2 && s.static)
    return rn(i);
  if (t & 1) {
    let l = (a = s.unmount) == null || a ? 0 : 1;
    return Vt(l, { [0]() {
      return null;
    }, [1]() {
      return rn({ ...r, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return rn(i);
}
function rn({ props: e, attrs: t, slots: n, slot: o, name: r }) {
  var a;
  let { as: s, ...i } = ul(e, ["unmount", "static"]), l = (a = n.default) == null ? void 0 : a.call(n, o), u = {};
  if (s === "template") {
    if (l = ir(l), Object.keys(i).length > 0 || Object.keys(t).length > 0) {
      let [d, ...c] = l != null ? l : [];
      if (!cl(d) || c.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${r} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(i).concat(Object.keys(t)).sort((f, p) => f.localeCompare(p)).map((f) => `  - ${f}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((f) => `  - ${f}`).join(`
`)].join(`
`));
      return Or(d, Object.assign({}, i, u));
    }
    return Array.isArray(l) && l.length === 1 ? l[0] : l;
  }
  return ln(s, Object.assign({}, i, u), l);
}
function ir(e) {
  return e.flatMap((t) => t.type === _e ? ir(t.children) : [t]);
}
function sl(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let o of e)
    for (let r in o)
      r.startsWith("on") && typeof o[r] == "function" ? (n[r] != null || (n[r] = []), n[r].push(o[r])) : t[r] = o[r];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(n).map((o) => [o, void 0])));
  for (let o in n)
    Object.assign(t, { [o](r, ...a) {
      let s = n[o];
      for (let i of s) {
        if (r != null && r.defaultPrevented)
          return;
        i(r, ...a);
      }
    } });
  return t;
}
function ll(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function ul(e, t = []) {
  let n = Object.assign({}, e);
  for (let o of t)
    o in n && delete n[o];
  return n;
}
function cl(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
let dl = 0;
function fl() {
  return ++dl;
}
function tt() {
  return fl();
}
var J = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(J || {});
function pl(e) {
  throw new Error("Unexpected object: " + e);
}
var he = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(he || {});
function ml(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let o = t.resolveActiveIndex(), r = o != null ? o : -1, a = (() => {
    switch (e.focus) {
      case 0:
        return n.findIndex((s) => !t.resolveDisabled(s));
      case 1: {
        let s = n.slice().reverse().findIndex((i, l, u) => r !== -1 && u.length - l - 1 >= r ? !1 : !t.resolveDisabled(i));
        return s === -1 ? s : n.length - 1 - s;
      }
      case 2:
        return n.findIndex((s, i) => i <= r ? !1 : !t.resolveDisabled(s));
      case 3: {
        let s = n.slice().reverse().findIndex((i) => !t.resolveDisabled(i));
        return s === -1 ? s : n.length - 1 - s;
      }
      case 4:
        return n.findIndex((s) => t.resolveId(s) === e.id);
      case 5:
        return null;
      default:
        pl(e);
    }
  })();
  return a === -1 ? o : a;
}
function Z(e) {
  var t;
  return e == null || e.value == null ? null : (t = e.value.$el) != null ? t : e.value;
}
let ar = Symbol("Context");
var Ft = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ft || {});
function hl() {
  return Q(ar, null);
}
function vl(e) {
  Te(ar, e);
}
function ho(e, t) {
  if (e)
    return e;
  let n = t != null ? t : "button";
  if (typeof n == "string" && n.toLowerCase() === "button")
    return "button";
}
function sr(e, t) {
  let n = y(ho(e.value.type, e.value.as));
  return Ze(() => {
    n.value = ho(e.value.type, e.value.as);
  }), et(() => {
    var o;
    n.value || !Z(t) || Z(t) instanceof HTMLButtonElement && !((o = Z(t)) != null && o.hasAttribute("type")) && (n.value = "button");
  }), n;
}
function lr(e) {
  if (typeof window > "u")
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = Z(e);
    if (t)
      return t.ownerDocument;
  }
  return document;
}
function gl({ container: e, accept: t, walk: n, enabled: o }) {
  et(() => {
    let r = e.value;
    if (!r || o !== void 0 && !o.value)
      return;
    let a = lr(e);
    if (!a)
      return;
    let s = Object.assign((l) => t(l), { acceptNode: t }), i = a.createTreeWalker(r, NodeFilter.SHOW_ELEMENT, s, !1);
    for (; i.nextNode(); )
      n(i.currentNode);
  });
}
let vo = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var wl = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(wl || {}), _l = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(_l || {}), bl = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(bl || {}), Mn = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Mn || {});
function ur(e, t = 0) {
  var n;
  return e === ((n = lr(e)) == null ? void 0 : n.body) ? !1 : Vt(t, { [0]() {
    return e.matches(vo);
  }, [1]() {
    let o = e;
    for (; o !== null; ) {
      if (o.matches(vo))
        return !0;
      o = o.parentElement;
    }
    return !1;
  } });
}
function yl(e, t = (n) => n) {
  return e.slice().sort((n, o) => {
    let r = t(n), a = t(o);
    if (r === null || a === null)
      return 0;
    let s = r.compareDocumentPosition(a);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function go(e, t, n) {
  typeof window < "u" && et((o) => {
    window.addEventListener(e, t, n), o(() => window.removeEventListener(e, t, n));
  });
}
function Sl(e, t, n = M(() => !0)) {
  function o(r, a) {
    if (!n.value || r.defaultPrevented)
      return;
    let s = a(r);
    if (s === null || !s.ownerDocument.documentElement.contains(s))
      return;
    let i = function l(u) {
      return typeof u == "function" ? l(u()) : Array.isArray(u) || u instanceof Set ? u : [u];
    }(e);
    for (let l of i) {
      if (l === null)
        continue;
      let u = l instanceof HTMLElement ? l : Z(l);
      if (u != null && u.contains(s))
        return;
    }
    return !ur(s, Mn.Loose) && s.tabIndex !== -1 && r.preventDefault(), t(r, s);
  }
  go("click", (r) => o(r, (a) => a.target), !0), go("blur", (r) => o(r, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var cr = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(cr || {});
let xl = j({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    let { features: o, ...r } = e, a = { "aria-hidden": (o & 2) === 2 ? !0 : void 0, style: { position: "absolute", width: 1, height: 1, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
    return De({ ourProps: a, theirProps: r, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} });
function Il(e) {
  var t;
  let n = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (n) {
    for (let o of n.elements)
      if (o.tagName === "INPUT" && o.type === "submit" || o.tagName === "BUTTON" && o.type === "submit" || o.nodeName === "INPUT" && o.type === "image") {
        o.click();
        return;
      }
  }
}
let dr = Symbol("DescriptionContext");
function El() {
  let e = Q(dr, null);
  if (e === null)
    throw new Error("Missing parent");
  return e;
}
function $l({ slot: e = y({}), name: t = "Description", props: n = {} } = {}) {
  let o = y([]);
  function r(a) {
    return o.value.push(a), () => {
      let s = o.value.indexOf(a);
      s !== -1 && o.value.splice(s, 1);
    };
  }
  return Te(dr, { register: r, slot: e, name: t, props: n }), M(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
let Oc = j({ name: "Description", props: { as: { type: [Object, String], default: "p" } }, setup(e, { attrs: t, slots: n }) {
  let o = El(), r = `headlessui-description-${tt()}`;
  return Ze(() => Bt(o.register(r))), () => {
    let { name: a = "Description", slot: s = y({}), props: i = {} } = o, l = e, u = { ...Object.entries(i).reduce((d, [c, f]) => Object.assign(d, { [c]: v(f) }), {}), id: r };
    return De({ ourProps: u, theirProps: l, slot: s.value, attrs: t, slots: n, name: a });
  };
} });
var Tl = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Tl || {}), Ol = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Ol || {});
function kl(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let fr = Symbol("MenuContext");
function Yt(e) {
  let t = Q(fr, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Yt), n;
  }
  return t;
}
let Cl = j({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: n }) {
  let o = y(1), r = y(null), a = y(null), s = y([]), i = y(""), l = y(null), u = y(1);
  function d(f = (p) => p) {
    let p = l.value !== null ? s.value[l.value] : null, m = yl(f(s.value.slice()), (_) => Z(_.dataRef.domRef)), h = p ? m.indexOf(p) : null;
    return h === -1 && (h = null), { items: m, activeItemIndex: h };
  }
  let c = { menuState: o, buttonRef: r, itemsRef: a, items: s, searchQuery: i, activeItemIndex: l, activationTrigger: u, closeMenu: () => {
    o.value = 1, l.value = null;
  }, openMenu: () => o.value = 0, goToItem(f, p, m) {
    let h = d(), _ = ml(f === he.Specific ? { focus: he.Specific, id: p } : { focus: f }, { resolveItems: () => h.items, resolveActiveIndex: () => h.activeItemIndex, resolveId: (P) => P.id, resolveDisabled: (P) => P.dataRef.disabled });
    i.value = "", l.value = _, u.value = m != null ? m : 1, s.value = h.items;
  }, search(f) {
    let p = i.value !== "" ? 0 : 1;
    i.value += f.toLowerCase();
    let m = (l.value !== null ? s.value.slice(l.value + p).concat(s.value.slice(0, l.value + p)) : s.value).find((_) => _.dataRef.textValue.startsWith(i.value) && !_.dataRef.disabled), h = m ? s.value.indexOf(m) : -1;
    h === -1 || h === l.value || (l.value = h, u.value = 1);
  }, clearSearch() {
    i.value = "";
  }, registerItem(f, p) {
    let m = d((h) => [...h, { id: f, dataRef: p }]);
    s.value = m.items, l.value = m.activeItemIndex, u.value = 1;
  }, unregisterItem(f) {
    let p = d((m) => {
      let h = m.findIndex((_) => _.id === f);
      return h !== -1 && m.splice(h, 1), m;
    });
    s.value = p.items, l.value = p.activeItemIndex, u.value = 1;
  } };
  return Sl([r, a], (f, p) => {
    var m;
    c.closeMenu(), ur(p, Mn.Loose) || (f.preventDefault(), (m = Z(r)) == null || m.focus());
  }, M(() => o.value === 0)), Te(fr, c), vl(M(() => Vt(o.value, { [0]: Ft.Open, [1]: Ft.Closed }))), () => {
    let f = { open: o.value === 0 };
    return De({ ourProps: {}, theirProps: e, slot: f, slots: t, attrs: n, name: "Menu" });
  };
} }), Dl = j({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" } }, setup(e, { attrs: t, slots: n, expose: o }) {
  let r = Yt("MenuButton"), a = `headlessui-menu-button-${tt()}`;
  o({ el: r.buttonRef, $el: r.buttonRef });
  function s(d) {
    switch (d.key) {
      case J.Space:
      case J.Enter:
      case J.ArrowDown:
        d.preventDefault(), d.stopPropagation(), r.openMenu(), ve(() => {
          var c;
          (c = Z(r.itemsRef)) == null || c.focus({ preventScroll: !0 }), r.goToItem(he.First);
        });
        break;
      case J.ArrowUp:
        d.preventDefault(), d.stopPropagation(), r.openMenu(), ve(() => {
          var c;
          (c = Z(r.itemsRef)) == null || c.focus({ preventScroll: !0 }), r.goToItem(he.Last);
        });
        break;
    }
  }
  function i(d) {
    switch (d.key) {
      case J.Space:
        d.preventDefault();
        break;
    }
  }
  function l(d) {
    e.disabled || (r.menuState.value === 0 ? (r.closeMenu(), ve(() => {
      var c;
      return (c = Z(r.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })) : (d.preventDefault(), r.openMenu(), kl(() => {
      var c;
      return (c = Z(r.itemsRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })));
  }
  let u = sr(M(() => ({ as: e.as, type: t.type })), r.buttonRef);
  return () => {
    var d;
    let c = { open: r.menuState.value === 0 }, f = { ref: r.buttonRef, id: a, type: u.value, "aria-haspopup": !0, "aria-controls": (d = Z(r.itemsRef)) == null ? void 0 : d.id, "aria-expanded": e.disabled ? void 0 : r.menuState.value === 0, onKeydown: s, onKeyup: i, onClick: l };
    return De({ ourProps: f, theirProps: e, slot: c, attrs: t, slots: n, name: "MenuButton" });
  };
} }), Pl = j({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(e, { attrs: t, slots: n, expose: o }) {
  let r = Yt("MenuItems"), a = `headlessui-menu-items-${tt()}`, s = y(null);
  o({ el: r.itemsRef, $el: r.itemsRef }), gl({ container: M(() => Z(r.itemsRef)), enabled: M(() => r.menuState.value === 0), accept(c) {
    return c.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : c.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(c) {
    c.setAttribute("role", "none");
  } });
  function i(c) {
    var f;
    switch (s.value && clearTimeout(s.value), c.key) {
      case J.Space:
        if (r.searchQuery.value !== "")
          return c.preventDefault(), c.stopPropagation(), r.search(c.key);
      case J.Enter:
        if (c.preventDefault(), c.stopPropagation(), r.activeItemIndex.value !== null) {
          let p = r.items.value[r.activeItemIndex.value];
          (f = Z(p.dataRef.domRef)) == null || f.click();
        }
        r.closeMenu(), ve(() => {
          var p;
          return (p = Z(r.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        });
        break;
      case J.ArrowDown:
        return c.preventDefault(), c.stopPropagation(), r.goToItem(he.Next);
      case J.ArrowUp:
        return c.preventDefault(), c.stopPropagation(), r.goToItem(he.Previous);
      case J.Home:
      case J.PageUp:
        return c.preventDefault(), c.stopPropagation(), r.goToItem(he.First);
      case J.End:
      case J.PageDown:
        return c.preventDefault(), c.stopPropagation(), r.goToItem(he.Last);
      case J.Escape:
        c.preventDefault(), c.stopPropagation(), r.closeMenu(), ve(() => {
          var p;
          return (p = Z(r.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        });
        break;
      case J.Tab:
        c.preventDefault(), c.stopPropagation();
        break;
      default:
        c.key.length === 1 && (r.search(c.key), s.value = setTimeout(() => r.clearSearch(), 350));
        break;
    }
  }
  function l(c) {
    switch (c.key) {
      case J.Space:
        c.preventDefault();
        break;
    }
  }
  let u = hl(), d = M(() => u !== null ? u.value === Ft.Open : r.menuState.value === 0);
  return () => {
    var c, f;
    let p = { open: r.menuState.value === 0 }, m = { "aria-activedescendant": r.activeItemIndex.value === null || (c = r.items.value[r.activeItemIndex.value]) == null ? void 0 : c.id, "aria-labelledby": (f = Z(r.buttonRef)) == null ? void 0 : f.id, id: a, onKeydown: i, onKeyup: l, role: "menu", tabIndex: 0, ref: r.itemsRef };
    return De({ ourProps: m, theirProps: e, slot: p, attrs: t, slots: n, features: gn.RenderStrategy | gn.Static, visible: d.value, name: "MenuItems" });
  };
} }), nt = j({ name: "MenuItem", props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: n, expose: o }) {
  let r = Yt("MenuItem"), a = `headlessui-menu-item-${tt()}`, s = y(null);
  o({ el: s, $el: s });
  let i = M(() => r.activeItemIndex.value !== null ? r.items.value[r.activeItemIndex.value].id === a : !1), l = M(() => ({ disabled: e.disabled, textValue: "", domRef: s }));
  Ze(() => {
    var p, m;
    let h = (m = (p = Z(s)) == null ? void 0 : p.textContent) == null ? void 0 : m.toLowerCase().trim();
    h !== void 0 && (l.value.textValue = h);
  }), Ze(() => r.registerItem(a, l)), Bt(() => r.unregisterItem(a)), et(() => {
    r.menuState.value === 0 && (!i.value || r.activationTrigger.value !== 0 && ve(() => {
      var p, m;
      return (m = (p = Z(s)) == null ? void 0 : p.scrollIntoView) == null ? void 0 : m.call(p, { block: "nearest" });
    }));
  });
  function u(p) {
    if (e.disabled)
      return p.preventDefault();
    r.closeMenu(), ve(() => {
      var m;
      return (m = Z(r.buttonRef)) == null ? void 0 : m.focus({ preventScroll: !0 });
    });
  }
  function d() {
    if (e.disabled)
      return r.goToItem(he.Nothing);
    r.goToItem(he.Specific, a);
  }
  function c() {
    e.disabled || i.value || r.goToItem(he.Specific, a, 0);
  }
  function f() {
    e.disabled || !i.value || r.goToItem(he.Nothing);
  }
  return () => {
    let { disabled: p } = e, m = { active: i.value, disabled: p };
    return De({ ourProps: { id: a, ref: s, role: "menuitem", tabIndex: p === !0 ? void 0 : -1, "aria-disabled": p === !0 ? !0 : void 0, onClick: u, onFocus: d, onPointermove: c, onMousemove: c, onPointerleave: f, onMouseleave: f }, theirProps: e, slot: m, attrs: n, slots: t, name: "MenuItem" });
  };
} }), pr = Symbol("LabelContext");
function mr() {
  let e = Q(pr, null);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, mr), t;
  }
  return e;
}
function Al({ slot: e = {}, name: t = "Label", props: n = {} } = {}) {
  let o = y([]);
  function r(a) {
    return o.value.push(a), () => {
      let s = o.value.indexOf(a);
      s !== -1 && o.value.splice(s, 1);
    };
  }
  return Te(pr, { register: r, slot: e, name: t, props: n }), M(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
let kc = j({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 } }, setup(e, { slots: t, attrs: n }) {
  let o = mr(), r = `headlessui-label-${tt()}`;
  return Ze(() => Bt(o.register(r))), () => {
    let { name: a = "Label", slot: s = {}, props: i = {} } = o, { passive: l, ...u } = e, d = { ...Object.entries(i).reduce((c, [f, p]) => Object.assign(c, { [f]: v(p) }), {}), id: r };
    return l && (delete d.onClick, delete u.onClick), De({ ourProps: d, theirProps: u, slot: s, attrs: n, slots: t, name: a });
  };
} }), hr = Symbol("GroupContext");
j({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: n }) {
  let o = y(null), r = Al({ name: "SwitchLabel", props: { onClick() {
    !o.value || (o.value.click(), o.value.focus({ preventScroll: !0 }));
  } } }), a = $l({ name: "SwitchDescription" });
  return Te(hr, { switchRef: o, labelledby: r, describedby: a }), () => De({ theirProps: e, ourProps: {}, slot: {}, slots: t, attrs: n, name: "SwitchGroup" });
} });
let ql = j({ name: "Switch", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: !1 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 } }, inheritAttrs: !1, setup(e, { emit: t, attrs: n, slots: o, expose: r }) {
  let a = Q(hr, null), s = `headlessui-switch-${tt()}`;
  function i() {
    t("update:modelValue", !e.modelValue);
  }
  let l = y(null), u = a === null ? l : a.switchRef, d = sr(M(() => ({ as: e.as, type: n.type })), u);
  r({ el: u, $el: u });
  function c(m) {
    m.preventDefault(), i();
  }
  function f(m) {
    m.key === J.Space ? (m.preventDefault(), i()) : m.key === J.Enter && Il(m.currentTarget);
  }
  function p(m) {
    m.preventDefault();
  }
  return () => {
    let { name: m, value: h, modelValue: _, ...P } = e, C = { checked: _ }, D = { id: s, ref: u, role: "switch", type: d.value, tabIndex: 0, "aria-checked": _, "aria-labelledby": a == null ? void 0 : a.labelledby.value, "aria-describedby": a == null ? void 0 : a.describedby.value, onClick: c, onKeyup: f, onKeypress: p };
    return ln(_e, [m != null && _ != null ? ln(xl, ll({ features: cr.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: _, name: m, value: h })) : null, De({ ourProps: D, theirProps: { ...n, ...P }, slot: C, attrs: n, slots: o, name: "Switch" })]);
  };
} });
const wo = /* @__PURE__ */ j({
  __name: "ASwitch",
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    return (n, o) => {
      const r = il;
      return w(), B(v(ql), {
        "model-value": e.modelValue,
        class: "tw-p-3 tw-cursor-pointer hover:tw-text-indigo-500 tw-transition-colors tw-relative",
        "onUpdate:modelValue": o[0] || (o[0] = (a) => t("update:modelValue", a))
      }, {
        default: O(() => [
          b("span", {
            class: le(["tw-text-2xl tw-absolute tw-left-1/2 -tw-translate-x-1/2 tw-transition-transform tw-origin-center", { "tw-scale-0": e.modelValue }])
          }, [
            x(r, { class: "tw-rotate-180" })
          ], 2),
          ue(n.$slots, "default")
        ]),
        _: 3
      }, 8, ["model-value"]);
    };
  }
}), vr = (e) => (kr("data-v-f0809b7e"), e = e(), Cr(), e), Ml = { class: "tw-sticky tw-top-6 tw-z-30 tw-mb-9 tw-mx-auto tw-grid tw-grid-cols-[minmax(0,1fr)_min-content_minmax(0,1fr)] tw-gap-6" }, Nl = /* @__PURE__ */ vr(() => /* @__PURE__ */ b("div", { class: "tw-flex tw-items-center tw-justify-end" }, null, -1)), Rl = { class: "tw-bg-indigo-100 tw-rounded-full tw-flex tw-items-stretch tw-text-2xl tw-overflow-hidden tw-shadow-lg tw-border-blue-400 tw-border" }, jl = { class: "tw-flex" }, Fl = { class: "tw-sr-only" }, Bl = { class: "tw-sr-only" }, Ll = { class: "tw-text-lg" }, zl = /* @__PURE__ */ vr(() => /* @__PURE__ */ b("div", { class: "tw-flex tw-items-center tw-justify-start" }, null, -1)), Ul = /* @__PURE__ */ j({
  __name: "ACommandBar",
  props: {
    showAllNotes: { type: Boolean },
    showAllSpeakerTexts: { type: Boolean },
    isSaving: { type: Boolean },
    numUndoOperations: null,
    numRedoOperations: null
  },
  emits: ["update:showAllNotes", "update:showAllSpeakerTexts", "save", "undo", "redo"],
  setup(e, { emit: t }) {
    const n = Q("i18n");
    return (o, r) => {
      const a = En, s = $n, i = el, l = Gs, u = je, d = Hs, c = Fs;
      return w(), I("div", Ml, [
        Nl,
        b("div", Rl, [
          b("div", jl, [
            x(wo, {
              "model-value": e.showAllNotes,
              title: e.showAllNotes ? v(n).builder.hideNotes : v(n).builder.showNotes,
              "onUpdate:modelValue": r[0] || (r[0] = (f) => t("update:showAllNotes", f))
            }, {
              default: O(() => [
                b("span", Fl, X(v(n).builder.showNotes), 1),
                x(a)
              ]),
              _: 1
            }, 8, ["model-value", "title"]),
            x(wo, {
              "model-value": e.showAllSpeakerTexts,
              title: e.showAllSpeakerTexts ? v(n).builder.hideSpeakerTexts : v(n).builder.showSpeakerTexts,
              "onUpdate:modelValue": r[1] || (r[1] = (f) => t("update:showAllSpeakerTexts", f))
            }, {
              default: O(() => [
                b("span", Bl, X(v(n).builder.showSpeakerTexts), 1),
                x(s)
              ]),
              _: 1
            }, 8, ["model-value", "title"]),
            x(u, {
              size: "large",
              flavour: "indigo",
              round: "",
              disabled: e.isSaving || e.numUndoOperations === 0,
              onClick: r[2] || (r[2] = (f) => t("save"))
            }, {
              default: O(() => [
                e.isSaving ? (w(), B(l, {
                  key: 1,
                  class: "tw-animate-spin"
                })) : (w(), B(i, { key: 0 })),
                b("span", Ll, X(v(n).builder.save), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            x(u, {
              round: "",
              flavour: "indigo-blend",
              size: "none",
              class: "tw-p-3 csb-number-badge csb-right",
              "data-number-badge": e.numUndoOperations > 0 ? e.numUndoOperations : null,
              disabled: e.numUndoOperations === 0,
              title: v(n).builder.undo,
              "data-csb-undo": "",
              onClick: r[3] || (r[3] = (f) => t("undo"))
            }, {
              default: O(() => [
                x(d)
              ]),
              _: 1
            }, 8, ["data-number-badge", "disabled", "title"]),
            x(u, {
              round: "",
              flavour: "indigo-blend",
              size: "none",
              class: "tw-p-3 csb-number-badge csb-left",
              "data-number-badge": e.numRedoOperations > 0 ? e.numRedoOperations : null,
              disabled: e.numRedoOperations === 0,
              title: v(n).builder.redo,
              "data-csb-redo": "",
              onClick: r[4] || (r[4] = (f) => t("redo"))
            }, {
              default: O(() => [
                x(c)
              ]),
              _: 1
            }, 8, ["data-number-badge", "disabled", "title"])
          ])
        ]),
        zl
      ]);
    };
  }
});
const Fe = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, Hl = /* @__PURE__ */ Fe(Ul, [["__scopeId", "data-v-f0809b7e"]]), Vl = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Yl = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M5.5 4.5h10v12a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2zm5-2a2 2 0 0 1 1.995 1.85l.005.15h-4a2 2 0 0 1 2-2zm-7 2h14m-9 3v8m4-8v8"
}, null, -1), Wl = [
  Yl
];
function Xl(e, t) {
  return w(), I("svg", Vl, Wl);
}
const gr = { name: "system-uicons-trash", render: Xl };
function Gl(e) {
  function t() {
    e.value && (e.value.style.height = "auto", e.value.style.height = `calc(${e.value.scrollHeight}px + 10px)`);
  }
  et((n) => {
    e.value && (t(), e.value.addEventListener("input", t), n(() => {
      e.value && e.value.removeEventListener("input", t);
    }));
  });
}
let Kl = 0;
const an = {};
function wn(e, t) {
  const n = `${e}-${Kl++}`;
  return t ? (t = `${e}-${t}`, Object.prototype.hasOwnProperty.call(an, t) || (an[t] = n), y(an[t])) : y(n);
}
const Zl = ["src"], Ql = /* @__PURE__ */ j({
  __name: "AAudiofile",
  props: {
    audiofile: null
  },
  setup(e, { expose: t }) {
    const n = e;
    return t({
      audiofile: M(() => n.audiofile)
    }), (o, r) => (w(), I("audio", {
      src: e.audiofile.streamUrl,
      controls: "",
      class: "tw-rounded-full",
      disableremoteplayback: "",
      "x-webkit-airplay": "deny",
      preload: "metadata"
    }, null, 8, Zl));
  }
});
const wr = /* @__PURE__ */ Fe(Ql, [["__scopeId", "data-v-0c0313b7"]]), Jl = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, eu = /* @__PURE__ */ b("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ b("path", { d: "M18.5 12.5v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2z" }),
  /* @__PURE__ */ b("path", { d: "M6.5 6.503h-2a2 2 0 0 0-2 2V16.5a2 2 0 0 0 2 2h.003l8-.014a2 2 0 0 0 1.997-2v-1.983m-2-9.003v6m3-3h-6" })
], -1), tu = [
  eu
];
function nu(e, t) {
  return w(), I("svg", Jl, tu);
}
const ou = { name: "system-uicons-duplicate", render: nu }, ru = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, iu = /* @__PURE__ */ b("g", {
  fill: "currentColor",
  "fill-rule": "evenodd"
}, [
  /* @__PURE__ */ b("circle", {
    cx: "10.5",
    cy: "10.5",
    r: "1"
  }),
  /* @__PURE__ */ b("circle", {
    cx: "10.5",
    cy: "5.5",
    r: "1"
  }),
  /* @__PURE__ */ b("circle", {
    cx: "10.5",
    cy: "15.5",
    r: "1"
  })
], -1), au = [
  iu
];
function su(e, t) {
  return w(), I("svg", ru, au);
}
const lu = { name: "system-uicons-menu-vertical", render: su }, uu = { class: "tw-p-1" }, cu = /* @__PURE__ */ j({
  __name: "AContentSequenceItemMenu",
  props: {
    itemId: null,
    allowCopy: { type: Boolean },
    allowEmbed: { type: Boolean }
  },
  emits: ["showAudiofileDialog", "showSequenceDialog", "unassignSchedule", "copy", "delete"],
  setup(e, { emit: t }) {
    const o = wn("menu-button", e.itemId), r = (s, i = !1) => [
      "tw-flex tw-gap-2 tw-w-full tw-items-center tw-rounded-md tw-px-2 tw-py-2 tw-text-sm",
      {
        "tw-bg-rose-500 tw-text-white": s && i,
        "tw-bg-gray-200": s && !i,
        "tw-text-gray-900": !s
      }
    ], a = Q("i18n");
    return (s, i) => {
      const l = lu, u = In, d = Ut, c = ou, f = gr;
      return w(), B(v(Cl), {
        as: "div",
        class: "tw-relative tw-inline-block tw-text-left",
        "data-csb-menu": ""
      }, {
        default: O(() => [
          b("div", null, [
            x(je, {
              is: v(Dl),
              id: v(o),
              round: "",
              size: "none",
              flavour: "gray-blend",
              class: "tw-text-7xl tw-p-2 tw-items-center tw-overflow-hidden",
              "data-csb-menubutton": ""
            }, {
              default: O(() => [
                x(l, {
                  style: { "shape-rendering": "geometricPrecision" },
                  "aria-hidden": "true",
                  class: "tw-w-8 tw-h-8"
                })
              ]),
              _: 1
            }, 8, ["is", "id"])
          ]),
          x(Dr, {
            "enter-active-class": "tw-transition tw-duration-100 tw-ease-out",
            "enter-from-class": "tw-transform tw-scale-95 tw-opacity-0",
            "enter-to-class": "tw-transform tw-scale-100 tw-opacity-100",
            "leave-active-class": "tw-transition tw-duration-75 tw-ease-in",
            "leave-from-class": "tw-transform tw-scale-100 tw-opacity-100",
            "leave-to-class": "tw-transform tw-scale-95 tw-opacity-0"
          }, {
            default: O(() => [
              x(v(Pl), { class: "tw-absolute tw-right-0 tw-mt-2 tw-w-64 tw-origin-top-right tw-divide-y tw-divide-gray-100 tw-rounded-md tw-bg-white tw-shadow-lg focus:tw-outline-none tw-z-10" }, {
                default: O(() => [
                  b("div", uu, [
                    x(v(nt), null, {
                      default: O(({ active: p }) => [
                        b("button", {
                          class: le(r(p)),
                          "data-csb-menu-select-audio": "",
                          onClick: i[0] || (i[0] = (m) => t("showAudiofileDialog"))
                        }, [
                          x(u, {
                            class: "tw-h-5 tw-w-5",
                            "aria-hidden": "true"
                          }),
                          pe(" " + X(v(a).audio.select), 1)
                        ], 2)
                      ]),
                      _: 1
                    }),
                    e.allowEmbed ? (w(), B(v(nt), { key: 0 }, {
                      default: O(({ active: p }) => [
                        b("button", {
                          class: le(r(p)),
                          "data-csb-menu-select-sequence": "",
                          onClick: i[1] || (i[1] = (m) => t("showSequenceDialog"))
                        }, [
                          x(d, {
                            class: "tw-h-5 tw-w-5",
                            "aria-hidden": "true"
                          }),
                          pe(" " + X(v(a).sequence.selectLabel), 1)
                        ], 2)
                      ]),
                      _: 1
                    })) : (w(), B(v(nt), { key: 1 }, {
                      default: O(({ active: p }) => [
                        b("button", {
                          class: le(r(p)),
                          "data-csb-menu-unassign-sequence": "",
                          onClick: i[2] || (i[2] = (m) => t("unassignSchedule"))
                        }, [
                          x(d, {
                            class: "tw-h-5 tw-w-5",
                            "aria-hidden": "true"
                          }),
                          pe(" " + X(v(a).sequence.deassign), 1)
                        ], 2)
                      ]),
                      _: 1
                    })),
                    e.allowCopy ? (w(), B(v(nt), { key: 2 }, {
                      default: O(({ active: p }) => [
                        b("button", {
                          class: le(r(p)),
                          "data-csb-menu-copy-sequence": "",
                          onClick: i[3] || (i[3] = (m) => t("copy"))
                        }, [
                          x(c, {
                            class: "tw-h-5 tw-w-5",
                            "aria-hidden": "true"
                          }),
                          pe(" " + X(v(a).sequenceItem.createCopy), 1)
                        ], 2)
                      ]),
                      _: 1
                    })) : L("", !0),
                    x(v(nt), null, {
                      default: O(({ active: p }) => [
                        b("button", {
                          class: le(r(p, !0)),
                          "data-csb-menu-delete": "",
                          onClick: i[4] || (i[4] = (m) => t("delete"))
                        }, [
                          x(f, {
                            class: "tw-h-5 tw-w-5",
                            "aria-hidden": "true"
                          }),
                          pe(" " + X(v(a).generic.delete), 1)
                        ], 2)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), du = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, fu = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "m7.5 7.5l6 6m0-6l-6 6"
}, null, -1), pu = [
  fu
];
function mu(e, t) {
  return w(), I("svg", du, pu);
}
const hu = { name: "system-uicons-close", render: mu }, vu = ["onKeydown"], gu = /* @__PURE__ */ j({
  __name: "ADialog",
  props: {
    modelValue: { type: Boolean },
    isModal: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = y();
    function r() {
      t("update:modelValue", !1);
    }
    function a(i) {
      if (o.value) {
        const l = o.value.getBoundingClientRect();
        l.top <= i.clientY && i.clientY <= l.top + l.height && l.left <= i.clientX && i.clientX <= l.left + l.width || r();
      }
    }
    sa(o, r), re(
      () => n.modelValue,
      async (i) => {
        i && !o.value && await ve(), o.value && (i ? n.isModal ? o.value.showModal() : o.value.show() : o.value.open && o.value.close());
      }
    );
    const s = Q("i18n");
    return (i, l) => {
      const u = hu, d = je;
      return e.modelValue ? (w(), I("dialog", {
        key: 0,
        ref_key: "dialogEl",
        ref: o,
        class: "tw-shadow-xl tw-border tw-border-gray-200 tw-rounded tw-p-6 tw-bg-white tw-z-30 tw-absolute",
        onClick: a,
        onKeydown: Pr(r, ["esc"])
      }, [
        ue(i.$slots, "default", {}, void 0, !0),
        x(d, {
          round: "",
          size: "none",
          class: "tw-absolute tw-top-5 tw-right-6 tw-w-8 tw-h-8",
          tabindex: "-1",
          title: v(s).generic.close,
          onClick: r
        }, {
          default: O(() => [
            x(u, { class: "tw-w-6 tw-h-6" })
          ]),
          _: 1
        }, 8, ["title"])
      ], 40, vu)) : L("", !0);
    };
  }
});
const _o = /* @__PURE__ */ Fe(gu, [["__scopeId", "data-v-be3c785d"]]), wu = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, _u = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M7.5 3.5h6a1 1 0 0 1 1 1v5a4 4 0 1 1-8 0v-5a1 1 0 0 1 1-1zm3 10v3m-3 0h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm7-11h2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2h-1zm-8 0h-2a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h1z"
}, null, -1), bu = [
  _u
];
function yu(e, t) {
  return w(), I("svg", wu, bu);
}
const Su = { name: "system-uicons-trophy", render: yu }, xu = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Iu = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M2 10.5c2.537 3.667 5.37 5.5 8.5 5.5s5.963-1.833 8.5-5.5M4.5 13.423l-2 2.077m14-2.077l2 2.077m-6 .5l1 2.5m-5-2.5l-1 2.5"
}, null, -1), Eu = [
  Iu
];
function $u(e, t) {
  return w(), I("svg", xu, Eu);
}
const Tu = { name: "system-uicons-eye-closed", render: $u }, Ou = ["id"], ku = ["id", "type"], Cu = {
  inheritAttrs: !1
}, _n = /* @__PURE__ */ j({
  ...Cu,
  __name: "AInput",
  props: {
    modelValue: null,
    type: { default: "text" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = ["tw-w-full", "tw-border-2", "tw-border-gray-200", "tw-rounded", "tw-p-3"], r = Ar(), a = Q("fieldId"), s = y(null);
    Gl(s);
    const i = M({
      get: () => n.modelValue,
      set: (l) => {
        t("update:modelValue", l);
      }
    });
    return (l, u) => (w(), I("div", null, [
      e.type === "textarea" ? Tt((w(), I("textarea", Rn({ key: 0 }, v(r), {
        id: v(a),
        ref_key: "textarea",
        ref: s,
        "onUpdate:modelValue": u[0] || (u[0] = (d) => sn(i) ? i.value = d : null),
        class: o
      }), null, 16, Ou)), [
        [qr, v(i)]
      ]) : Tt((w(), I("input", Rn({ key: 1 }, v(r), {
        id: v(a),
        "onUpdate:modelValue": u[1] || (u[1] = (d) => sn(i) ? i.value = d : null),
        type: e.type,
        class: o
      }), null, 16, ku)), [
        [Mr, v(i)]
      ])
    ]));
  }
}), Du = {}, Pu = { class: "tw-inline-flex tw-gap-x-2 tw-items-center tw-text-sm tw-font-bold tw-select-none tw-text-gray-400 tw-uppercase" };
function Au(e, t) {
  return w(), I("span", Pu, [
    ue(e.$slots, "default")
  ]);
}
const bn = /* @__PURE__ */ Fe(Du, [["render", Au]]);
var qu = { "": ["<em>", "</em>"], _: ["<strong>", "</strong>"], "*": ["<strong>", "</strong>"], "~": ["<s>", "</s>"], "\n": ["<br />"], " ": ["<br />"], "-": ["<hr />"] };
function bo(e) {
  return e.replace(RegExp("^" + (e.match(/^(\t| )+/) || "")[0], "gm"), "");
}
function ot(e) {
  return (e + "").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function pt(e, t) {
  var n, o, r, a, s, i = /((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:!\[([^\]]*?)\]\(([^)]+?)\))|(\[)|(\](?:\(([^)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*]|~~)/gm, l = [], u = "", d = t || {}, c = 0;
  function f(m) {
    var h = qu[m[1] || ""], _ = l[l.length - 1] == m;
    return h ? h[1] ? (_ ? l.pop() : l.push(m), h[0 | _]) : h[0] : m;
  }
  function p() {
    for (var m = ""; l.length; )
      m += f(l[l.length - 1]);
    return m;
  }
  for (e = e.replace(/^\[(.+?)\]:\s*(.+)$/gm, function(m, h, _) {
    return d[h.toLowerCase()] = _, "";
  }).replace(/^\n+|\n+$/g, ""); r = i.exec(e); )
    o = e.substring(c, r.index), c = i.lastIndex, n = r[0], o.match(/[^\\](\\\\)*\\$/) || ((s = r[3] || r[4]) ? n = '<pre class="code ' + (r[4] ? "poetry" : r[2].toLowerCase()) + '"><code' + (r[2] ? ' class="language-' + r[2].toLowerCase() + '"' : "") + ">" + bo(ot(s).replace(/^\n+|\n+$/g, "")) + "</code></pre>" : (s = r[6]) ? (s.match(/\./) && (r[5] = r[5].replace(/^\d+/gm, "")), a = pt(bo(r[5].replace(/^\s*[>*+.-]/gm, ""))), s == ">" ? s = "blockquote" : (s = s.match(/\./) ? "ol" : "ul", a = a.replace(/^(.*)(\n|$)/gm, "<li>$1</li>")), n = "<" + s + ">" + a + "</" + s + ">") : r[8] ? n = '<img src="' + ot(r[8]) + '" alt="' + ot(r[7]) + '">' : r[10] ? (u = u.replace("<a>", '<a href="' + ot(r[11] || d[o.toLowerCase()]) + '">'), n = p() + "</a>") : r[9] ? n = "<a>" : r[12] || r[14] ? n = "<" + (s = "h" + (r[14] ? r[14].length : r[13] > "=" ? 1 : 2)) + ">" + pt(r[12] || r[15], d) + "</" + s + ">" : r[16] ? n = "<code>" + ot(r[16]) + "</code>" : (r[17] || r[1]) && (n = f(r[17] || "--"))), u += o, u += n;
  return (u + e.substring(c) + p()).replace(/^\n+|\n+$/g, "");
}
const Mu = ["innerHTML"], Nu = /* @__PURE__ */ j({
  __name: "AMarkdown",
  props: {
    content: null
  },
  setup(e) {
    const t = e, n = M(() => pt(
      new DOMParser().parseFromString(t.content, "text/html").body.textContent || ""
    ).split(/(?:\r?\n){2,}/).map(
      (o) => [" ", "	", "#", "-", "*", ">"].some((r) => o.startsWith(r)) ? pt(o) : `<p>${pt(o)}</p>`
    ).join(`
`));
    return (o, r) => e.content ? (w(), I("div", {
      key: 0,
      class: "csb-markdown tw-inline tw-leading-tight tw-break-words tw-prose prose-ul:tw-my-0 prose-ol:tw-my-0 prose-p:tw-mb-1 prose-headings:tw-underline prose-headings:tw-mb-1 prose-headings:tw-mt-2 prose-headings:tw-font-semibold prose-h1:tw-text-xl prose-h2:tw-text-lg prose-h3:tw-text-base prose-h4:tw-font-normal",
      style: { hyphens: "auto" },
      "data-csb-markdown": "",
      innerHTML: v(n)
    }, null, 8, Mu)) : L("", !0);
  }
});
const yn = /* @__PURE__ */ Fe(Nu, [["__scopeId", "data-v-9189d115"]]), Ru = {
  key: 0,
  class: "tw-flex tw-flex-col tw-gap-3 tw-max-w-xl"
}, ju = { class: "tw-flex tw-gap-3 tw-items-center tw-mb-3" }, Fu = { class: "tw-flex-1" }, Bu = {
  key: 1,
  class: "tw-text-center"
}, Lu = { key: 0 }, zu = {
  key: 0,
  class: "tw-flex tw-flex-col tw-items-center tw-text-lg tw-font-semibold tw-m-6"
}, Uu = {
  key: 1,
  class: "tw-text-gray-600 -tw-mt-4"
}, Hu = {
  inheritAttrs: !1
}, _r = /* @__PURE__ */ j({
  ...Hu,
  __name: "AEmbed",
  props: {
    getTitle: null,
    getDescription: null,
    search: null,
    texts: null,
    id: null
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: t }) {
    const n = e, o = 5, r = Q("api"), a = y(""), s = Vi(a, 500), i = y([]), l = y(), u = y(1), d = y(!1);
    function c(h) {
      t("update:modelValue", h.id), t("close");
    }
    const { isLoading: f, fn: p } = $o(async function(h, _ = !1) {
      if (r != null && r.searchAudiofiles)
        if (_)
          i.value = [], u.value = 1, h && (await ve(), i.value = await Ot(
            await n.search(h, {
              page: 1,
              pageSize: o
            })
          ), d.value = i.value.length === 0);
        else {
          u.value += 1;
          let P = 0;
          for await (const C of n.search(h, {
            page: u.value,
            pageSize: o
          }))
            i.value.push(C), P += 1;
          P === 0 && (d.value = !0);
        }
    });
    Ra(l, () => p(s.value), { distance: 10 }), re(s, (h) => p(h, !0)), re(a, (h) => {
      h || (i.value = [], u.value = 1, d.value = !1);
    });
    const m = Q("i18n");
    return (h, _) => {
      const P = Tu, C = Su;
      return w(), I(_e, null, [
        x(At, {
          id: e.id,
          "is-editing": !0
        }, {
          label: O(() => [
            x(bn, null, {
              default: O(() => [
                ue(h.$slots, "label")
              ]),
              _: 3
            })
          ]),
          default: O(() => [
            x(_n, {
              modelValue: a.value,
              "onUpdate:modelValue": _[0] || (_[0] = (D) => a.value = D),
              type: "text",
              placeholder: e.texts.placeholder
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 3
        }, 8, ["id"]),
        b("div", {
          ref_key: "scroller",
          ref: l,
          class: "tw-max-h-[600px] tw-overflow-y-scroll tw-overflow-x-hidden"
        }, [
          i.value.length > 0 ? (w(), I("ul", Ru, [
            (w(!0), I(_e, null, $t(i.value, (D) => (w(), I("li", {
              key: D.id,
              class: "tw-p-6 tw-bg-gray-100 tw-rounded"
            }, [
              b("header", ju, [
                b("p", Fu, X(e.getTitle(D)), 1),
                ue(h.$slots, "header-post", { item: D })
              ]),
              x(yn, {
                content: e.getDescription(D),
                class: "tw-text-sm !tw-block !tw-mb-3 max-w-full break-words"
              }, null, 8, ["content"]),
              x(je, {
                class: "tw-bg-white !tw-px-6 !tw-py-2",
                onClick: (z) => c(D)
              }, {
                default: O(() => [
                  pe(X(e.texts.selectLabel), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))), 128))
          ])) : L("", !0),
          v(f) ? (w(), I("p", Bu, X(v(m).generic.loading), 1)) : L("", !0)
        ], 512),
        v(f) ? L("", !0) : (w(), I("footer", Lu, [
          d.value ? (w(), I("p", zu, [
            i.value.length === 0 ? (w(), I(_e, { key: 0 }, [
              pe(X(v(m).generic.noResults) + " ", 1),
              x(P, { class: "tw-w-12 tw-h-12 tw-text-gray-400" })
            ], 64)) : (w(), I(_e, { key: 1 }, [
              pe(X(v(m).generic.endOfResults) + " ", 1),
              x(C, { class: "tw-w-12 tw-h-12 tw-text-yellow-500" })
            ], 64))
          ])) : L("", !0),
          a.value ? L("", !0) : (w(), I("p", Uu, X(e.texts.searchHint), 1))
        ]))
      ], 64);
    };
  }
}), Vu = {
  inheritAttrs: !1
}, Yu = /* @__PURE__ */ j({
  ...Vu,
  __name: "AEmbedAudio",
  props: {
    id: null
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: t }) {
    const n = Q("api"), o = Q("i18n"), r = (s) => s.title, a = (s) => s.description;
    return (s, i) => {
      const l = In, u = wr;
      return w(), B(_r, {
        id: e.id,
        "get-title": r,
        "get-description": a,
        search: v(n).searchAudiofiles,
        texts: {
          placeholder: v(o).audio.searchPlaceholder,
          searchHint: v(o).audio.searchHint,
          selectLabel: v(o).audio.select
        },
        "onUpdate:modelValue": i[0] || (i[0] = (d) => t("update:modelValue", d)),
        onClose: i[1] || (i[1] = (d) => t("close"))
      }, {
        label: O(() => [
          x(l, { class: "tw-w-6 tw-h-6" }),
          pe(" " + X(v(o).audio.select), 1)
        ]),
        "header-post": O(({ item: d }) => [
          x(u, {
            audiofile: d,
            class: "tw-float-right"
          }, null, 8, ["audiofile"])
        ]),
        _: 1
      }, 8, ["id", "search", "texts"]);
    };
  }
}), Wu = {
  inheritAttrs: !1
}, Xu = /* @__PURE__ */ j({
  ...Wu,
  __name: "AEmbedSequence",
  props: {
    id: null,
    sourceContentSequenceId: null
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: t }) {
    const n = e, o = Q("api"), r = Q("i18n"), a = (l) => {
      var u, d;
      return (d = (u = l.relatedObject) == null ? void 0 : u.title) != null ? d : "";
    }, s = (l) => {
      var u, d;
      return (d = (u = l.relatedObject) == null ? void 0 : u.description) != null ? d : "";
    };
    async function* i(l, u) {
      yield* await o.searchContentSequences(
        l,
        { isEmbeddableIn: n.sourceContentSequenceId },
        u
      );
    }
    return (l, u) => {
      const d = Ut;
      return w(), B(_r, {
        id: e.id,
        "get-title": a,
        "get-description": s,
        search: i,
        texts: {
          placeholder: v(r).sequence.searchPlaceholder,
          searchHint: v(r).sequence.searchHint,
          selectLabel: v(r).sequence.select
        },
        "onUpdate:modelValue": u[0] || (u[0] = (c) => t("update:modelValue", c)),
        onClose: u[1] || (u[1] = (c) => t("close"))
      }, {
        label: O(() => [
          x(d, { class: "tw-w-6 tw-h-6" }),
          pe(" " + X(v(r).sequence.selectLabel), 1)
        ]),
        _: 1
      }, 8, ["id", "texts"]);
    };
  }
}), Gu = /* @__PURE__ */ j({
  __name: "AEntityLoader",
  props: {
    fetch: null,
    entityId: null
  },
  setup(e) {
    const t = e, n = y(null), o = y(!1), r = y(null);
    async function a() {
      try {
        o.value = !0, n.value = await t.fetch(t.entityId);
      } catch (s) {
        s instanceof Error ? r.value = s : r.value = new Error(String(s));
      } finally {
        o.value = !1;
      }
    }
    return a(), re(() => [t.entityId, t.fetch], a), (s, i) => (w(), I(_e, null, [
      n.value ? ue(s.$slots, "default", {
        key: 0,
        entity: n.value
      }) : L("", !0),
      n.value === null ? ue(s.$slots, "trigger", {
        key: 1,
        isLoading: o.value,
        load: a
      }) : L("", !0)
    ], 64));
  }
}), Ku = {
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 21 21",
  width: "1.2em",
  height: "1.2em"
}, Zu = /* @__PURE__ */ b("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M5.5 10.5h10m-5-5v10"
}, null, -1), Qu = [
  Zu
];
function Ju(e, t) {
  return w(), I("svg", Ku, Qu);
}
const ec = { name: "system-uicons-plus", render: Ju }, tc = {};
function nc(e, t) {
  const n = ec, o = je;
  return w(), B(o, {
    round: "",
    size: "none",
    flavour: "none",
    class: "tw-absolute tw-left-1/2 -tw-translate-x-2/4 tw-w-12 tw-h-12 tw-bg-green-100 tw-text-black/75 tw-shadow-lg tw-text-2xl tw-scale-0 tw-z-20 group-hover:tw-scale-100 hover:tw-bg-green-300 hover:tw-shadow-xl"
  }, {
    default: O(() => [
      x(n)
    ]),
    _: 1
  });
}
const yo = /* @__PURE__ */ Fe(tc, [["render", nc]]), oc = ["data-csb-item", "data-csb-item-order"], rc = { class: "tw-flex-1 tw-flex tw-flex-wrap tw-gap-6" }, ic = { class: "tw-max-w-prose tw-flex-1" }, ac = { class: "tw-mb-3" }, sc = {
  key: 0,
  class: "tw-min-w-[200px] tw-max-w-[300px] tw-grow-[2] tw-ml-auto"
}, lc = { class: "tw-flex tw-items-center tw-bg-green-200 tw-rounded-full tw-max-w-full audio" }, uc = { class: "tw-flex tw-flex-col tw-relative tw-flex-none tw-w-12 tw-ml-auto" }, cc = /* @__PURE__ */ j({
  __name: "AContentSequenceItem",
  props: {
    item: null,
    sourceContentSequenceId: null,
    allowInsertion: { type: Boolean },
    level: null,
    orderChanges: null
  },
  emits: ["copy", "delete", "insert", "update:internalNote", "update:speakersText", "update:audiofileId", "update:nestedSequenceId"],
  setup(e, { expose: t, emit: n }) {
    const o = e, r = y(!1), a = wn("speakers-text", o.item.id), s = wn("internal-note", o.item.id), i = y(!1), l = y(!1), u = y(!1), d = M(
      () => o.item.sourceSequenceId === o.sourceContentSequenceId
    ), c = Q("api"), f = Q("settings"), p = Q("i18n"), m = aa(async () => {
      if (!o.item.nestedSequenceId || !c || He(o.item.nestedSequenceId))
        return !1;
      {
        const H = await c.fetchContentSequence(o.item.nestedSequenceId);
        return !!H && H.sourceSequenceId !== o.sourceContentSequenceId;
      }
    }, !1), h = y(), _ = y(), { top: P, height: C, update: D } = Ho(h);
    re(() => o.orderChanges, D);
    const z = /!music(?:\((?<duration>[\s\d:dhmins]+)\))?/;
    return t({
      id: M(() => o.item.id),
      position: M(() => Et({ top: P, height: C })),
      duration: M(() => {
        var S;
        if (_.value)
          return _.value.audiofile.duration;
        const H = o.item.internalNote.match(z);
        return (S = H == null ? void 0 : H.groups) != null && S.duration ? Pt(H.groups.duration) : o.item.speakersText ? Rr(o.item.speakersText) : 0;
      }),
      relativeStartTime: M(() => o.item.relativeStartTime),
      type: M(() => o.item.internalNote.includes("!music") ? "music" : _.value ? "audio" : o.item.speakersText ? "moderation" : o.item.nestedSequenceId ? "embed" : o.item.internalNote ? "note" : "default")
    }), (H, S) => {
      var A, V, F;
      const ge = Ut, $e = $n, te = En, R = gr;
      return w(), I("div", {
        ref_key: "el",
        ref: h,
        class: "tw-flex",
        "data-csb-item": e.item.id,
        "data-csb-item-order": e.item.order
      }, [
        e.allowInsertion ? (w(), I(_e, { key: 0 }, [
          x(yo, {
            class: "tw-top-0 -tw-translate-y-1/2",
            title: v(p).sequenceItem.insertBefore,
            "data-csb-insert-before": "",
            onClick: S[0] || (S[0] = (T) => n("insert", "before"))
          }, null, 8, ["title"]),
          x(yo, {
            class: "tw-bottom-0 tw-translate-y-1/2",
            title: v(p).sequenceItem.insertAfter,
            "data-csb-insert-after": "",
            onClick: S[1] || (S[1] = (T) => n("insert", "after"))
          }, null, 8, ["title"])
        ], 64)) : L("", !0),
        e.level > 0 ? (w(), I("div", {
          key: 1,
          class: "tw-flex-none tw-flex tw-justify-end",
          style: Io({ width: `calc(${e.level} * var(--csb-indent-level-offset))` })
        }, [
          x(ge, { class: "tw-w-8 tw-h-8 tw-mr-4 tw-text-gray-300" })
        ], 4)) : L("", !0),
        b("div", rc, [
          b("div", ic, [
            Tt(b("div", ac, [
              x(At, {
                id: v(a),
                class: "tw-grow",
                "is-editing": r.value,
                "allow-editing": v(d),
                onEdit: S[4] || (S[4] = (T) => r.value = T)
              }, {
                label: O(() => [
                  x(bn, null, {
                    default: O(() => [
                      x($e),
                      pe(" " + X(v(p).sequenceItem.speakersText), 1)
                    ]),
                    _: 1
                  })
                ]),
                "not-editing": O(() => [
                  x(yn, {
                    content: e.item.speakersText
                  }, null, 8, ["content"])
                ]),
                default: O(() => [
                  x(_n, {
                    type: "textarea",
                    "model-value": e.item.speakersText,
                    "onUpdate:modelValue": S[2] || (S[2] = (T) => n("update:speakersText", T)),
                    onBlur: S[3] || (S[3] = (T) => r.value = !1)
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }, 8, ["id", "is-editing", "allow-editing"])
            ], 512), [
              [jn, (A = v(f)) == null ? void 0 : A.showAllSpeakerTexts]
            ]),
            Tt(b("div", null, [
              x(At, {
                id: v(s),
                class: "tw-grow",
                "is-editing": i.value,
                "allow-editing": v(d),
                onEdit: S[7] || (S[7] = (T) => i.value = T)
              }, {
                label: O(() => [
                  x(bn, null, {
                    default: O(() => [
                      x(te),
                      pe(" " + X(v(p).sequenceItem.internalNote), 1)
                    ]),
                    _: 1
                  })
                ]),
                "not-editing": O(() => [
                  x(yn, {
                    content: e.item.internalNote
                  }, null, 8, ["content"])
                ]),
                default: O(() => [
                  x(_n, {
                    type: "textarea",
                    "model-value": e.item.internalNote,
                    "onUpdate:modelValue": S[5] || (S[5] = (T) => n("update:internalNote", T)),
                    onBlur: S[6] || (S[6] = (T) => i.value = !1)
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }, 8, ["id", "is-editing", "allow-editing"])
            ], 512), [
              [jn, ((V = v(f)) == null ? void 0 : V.showAllNotes) && (v(d) || e.item.internalNote)]
            ])
          ]),
          e.item.audiofileId ? (w(), I("div", sc, [
            b("div", lc, [
              (F = v(c)) != null && F.fetchAudiofile ? (w(), B(Gu, {
                key: 0,
                "entity-id": e.item.audiofileId,
                fetch: v(c).fetchAudiofile
              }, {
                default: O(({ entity: T }) => [
                  x(wr, {
                    ref_key: "audio",
                    ref: _,
                    audiofile: T,
                    class: "tw-flex-auto tw-min-w-0"
                  }, null, 8, ["audiofile"])
                ]),
                _: 1
              }, 8, ["entity-id", "fetch"])) : L("", !0),
              v(d) ? (w(), B(je, {
                key: 1,
                class: "tw-flex-none tw-mr-2",
                flavour: "none",
                title: v(p).generic.deassign,
                onClick: S[8] || (S[8] = (T) => n("update:audiofileId", null))
              }, {
                default: O(() => [
                  x(R, { class: "tw-w-5 tw-h-5" })
                ]),
                _: 1
              }, 8, ["title"])) : L("", !0)
            ])
          ])) : L("", !0),
          b("div", uc, [
            v(d) ? (w(), B(cu, {
              key: 0,
              "item-id": e.item.id,
              "allow-copy": v(m),
              "allow-embed": e.item.nestedSequenceId === null,
              onDelete: S[9] || (S[9] = (T) => n("delete")),
              onCopy: S[10] || (S[10] = (T) => n("copy")),
              onUnassignSchedule: S[11] || (S[11] = (T) => n("update:nestedSequenceId", null)),
              onShowAudiofileDialog: S[12] || (S[12] = (T) => l.value = !0),
              onShowSequenceDialog: S[13] || (S[13] = (T) => u.value = !0)
            }, null, 8, ["item-id", "allow-copy", "allow-embed"])) : L("", !0),
            x(_o, {
              modelValue: l.value,
              "onUpdate:modelValue": S[16] || (S[16] = (T) => l.value = T),
              class: "tw-w-[36rem] tw-top-[48px] tw-left-auto tw-right-0 tw-mt-2",
              onClose: S[17] || (S[17] = (T) => l.value = !1),
              onCancel: S[18] || (S[18] = (T) => l.value = !1)
            }, {
              default: O(() => [
                x(Yu, {
                  id: `csb-audio-dialog-${e.item.id}`,
                  "onUpdate:modelValue": S[14] || (S[14] = (T) => n("update:audiofileId", T)),
                  onClose: S[15] || (S[15] = (T) => l.value = !1)
                }, null, 8, ["id"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            x(_o, {
              modelValue: u.value,
              "onUpdate:modelValue": S[21] || (S[21] = (T) => u.value = T),
              class: "tw-w-[36rem] tw-top-[48px] tw-left-auto tw-right-0 tw-mt-2",
              onClose: S[22] || (S[22] = (T) => u.value = !1),
              onCancel: S[23] || (S[23] = (T) => u.value = !1)
            }, {
              default: O(() => [
                x(Xu, {
                  id: `csb-sequence-dialog-${e.item.id}`,
                  "source-content-sequence-id": e.sourceContentSequenceId,
                  "onUpdate:modelValue": S[19] || (S[19] = (T) => n("update:nestedSequenceId", T)),
                  onClose: S[20] || (S[20] = (T) => u.value = !1)
                }, null, 8, ["id", "source-content-sequence-id"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ], 8, oc);
    };
  }
});
const dc = /* @__PURE__ */ Fe(cc, [["__scopeId", "data-v-b0a8978a"]]), fc = { class: "tw-w-[2px] tw-bg-gray-200 tw-relative" }, pc = /* @__PURE__ */ j({
  __name: "ATimeline",
  setup(e) {
    const t = y(), { top: n } = Ho(t), o = "tw-h-2 tw-w-2 tw-bg-gray-200 tw-rounded-full tw-absolute -tw-left-1/2 -tw-translate-x-0.5";
    return (r, a) => (w(), I("div", {
      ref_key: "el",
      ref: t,
      class: "tw-flex tw-relative tw-px-6"
    }, [
      b("div", fc, [
        b("div", {
          class: le(["tw-top-0", o])
        }),
        b("div", {
          class: le(["tw-bottom-0", o])
        })
      ]),
      b("ol", null, [
        ue(r.$slots, "default", { top: v(n) })
      ])
    ], 512));
  }
}), mc = {
  class: "tw-p-6 tw-bg-gray-100 tw-rounded",
  "data-csb": ""
}, hc = {
  key: 0,
  class: "tw-flex tw-flex-1 tw-items-center tw-justify-center"
}, vc = { class: "tw-font-semibold tw-text-sm tw-absolute tw-text-gray-700 -tw-bottom-1 tw-left-12 tw-ml-3" }, gc = ["data-csb-drag-group"], wc = {
  key: 0,
  class: "tw-col-span-2"
}, _c = { class: "tw-p-6 tw-grid tw-gap-x-3 tw-gap-y-6 tw-grid-cols-[48px_minmax(0,1fr)]" }, bc = { class: "tw-flex tw-flex-col" }, yc = ["title"], Sc = /* @__PURE__ */ j({
  __name: "AContentSequenceBuilder",
  props: {
    contentSequenceId: { type: Number, required: !0 },
    api: { type: Object, required: !0 },
    i18n: { type: Object, required: !0 }
  },
  setup(e) {
    const t = e, n = y({
      showAllNotes: !0,
      showAllSpeakerTexts: !0
    }), o = y([]), r = M(
      () => Array.from(Fr(o.value, t.contentSequenceId))
    ), a = M(() => o.value.length > 0), { batch: s, clear: i, pause: l, resume: u, commit: d, undo: c, undoStack: f, redo: p, redoStack: m } = Ea(o, {
      debounce: 500,
      deep: !0
    }), h = ja(), _ = M(() => h.value.filter(jr)), P = M(() => {
      const R = [];
      let A = 0;
      for (const V of o.value) {
        if (V.relativeStartTime === null)
          continue;
        const F = Pt(V.relativeStartTime);
        F < A && R.push(V), A = F;
      }
      return Object.fromEntries(R.map((V) => [V.id, V]));
    });
    function C(R) {
      const A = _.value.slice(0, R);
      return Vo(
        A.reduce((V, F) => (F.relativeStartTime ? Pt(F.relativeStartTime) : V) + F.duration, 0)
      );
    }
    async function D({ newIndex: R, oldIndex: A }) {
      s(() => {
        zr(o.value, t.contentSequenceId, A, R);
      });
    }
    async function z(R, A) {
      if (A === null)
        R.nestedSequenceId = null;
      else {
        const V = await Ot(
          kt(t.api.fetchContentSequenceItems, A)
        ), F = o.value.indexOf(R);
        s(() => {
          o.value.splice(F + 1, 0, ...V), R.nestedSequenceId = A;
        });
      }
    }
    const { isLoading: H, fn: S } = $o(async function() {
      l();
      try {
        await t.api.saveContentSequenceItems(
          t.contentSequenceId,
          o.value.filter((A) => A.sourceSequenceId === t.contentSequenceId)
        );
      } finally {
        u();
      }
      await ge();
    });
    async function ge() {
      const R = await Ot(
        kt(t.api.fetchContentSequenceItems, t.contentSequenceId)
      );
      i(), o.value = R, d();
    }
    function $e(R, A, V) {
      const F = o.value.find((T) => T.id === R);
      F && (F[A] = V);
    }
    const te = y(0);
    return re(
      () => o.value.map((R) => [R.order, R.nestedSequenceId]),
      Cn(() => {
        te.value++;
      }, 200)
    ), Te("api", t.api), Te("i18n", t.i18n), Te("settings", n), ge(), (R, A) => {
      const V = je, F = ss, T = pi;
      return w(), I("div", mc, [
        v(a) ? (w(), B(Hl, {
          key: 0,
          showAllNotes: n.value.showAllNotes,
          "onUpdate:showAllNotes": A[0] || (A[0] = (ne) => n.value.showAllNotes = ne),
          showAllSpeakerTexts: n.value.showAllSpeakerTexts,
          "onUpdate:showAllSpeakerTexts": A[1] || (A[1] = (ne) => n.value.showAllSpeakerTexts = ne),
          "is-saving": v(H),
          "num-undo-operations": v(f).length - 1,
          "num-redo-operations": v(m).length,
          onSave: v(S),
          onUndo: v(c),
          onRedo: v(p)
        }, null, 8, ["showAllNotes", "showAllSpeakerTexts", "is-saving", "num-undo-operations", "num-redo-operations", "onSave", "onUndo", "onRedo"])) : L("", !0),
        b("div", {
          class: le({ "tw-flex": v(a) })
        }, [
          v(a) ? L("", !0) : (w(), I("div", hc, [
            x(V, {
              flavour: "indigo",
              size: "medium",
              onClick: A[2] || (A[2] = (ne) => v(s)(() => v(Br)(o.value, e.contentSequenceId)))
            }, {
              default: O(() => [
                pe(X(e.i18n.sequenceItem.insertFirst), 1)
              ]),
              _: 1
            })
          ])),
          v(a) ? (w(), B(pc, {
            key: 1,
            class: "tw-w-44 tw-flex-none"
          }, {
            default: O(({ top: ne }) => [
              (w(!0), I(_e, null, $t(v(_), (Y, Pe) => (w(), B(F, {
                key: Y.id,
                item: Y,
                "top-offset": ne,
                "calculated-start-time": C(Pe),
                "has-invalid-start-time": !!v(P)[Y.id],
                "onUpdate:relativeStartTime": (be) => $e(Y.id, "relativeStartTime", be)
              }, null, 8, ["item", "top-offset", "calculated-start-time", "has-invalid-start-time", "onUpdate:relativeStartTime"]))), 128)),
              b("span", vc, X(C(v(_).length)), 1)
            ]),
            _: 1
          })) : L("", !0),
          v(a) ? (w(), B(v(qs), {
            key: 2,
            ref: "sortable",
            list: v(r),
            "item-key": (ne) => ne.data[0].data.id,
            tag: "ol",
            class: "tw-flex-auto",
            "data-csb-drag-target": "",
            options: {
              animation: 200,
              ghostClass: "csb-drag-ghost",
              handle: ".csb-drag-handle"
            },
            onUpdate: D
          }, {
            item: O(({ element: ne }) => [
              b("li", {
                class: "tw-bg-white tw-shadow-lg tw-rounded tw-mb-3 last:tw-mb-0 tw-relative tw-group",
                "data-csb-drag-group": ne.data[0].data.id
              }, [
                (w(!0), I(_e, null, $t(ne.data, ({ data: Y, level: Pe }, be) => (w(), I(_e, {
                  key: Y.id
                }, [
                  be > 0 ? (w(), I("hr", wc)) : L("", !0),
                  b("div", _c, [
                    b("div", bc, [
                      be === 0 ? (w(), I("span", {
                        key: 0,
                        title: e.i18n.generic.move,
                        class: "tw-cursor-grab tw-flex tw-justify-center tw-aspect-square csb-drag-handle",
                        "data-csb-drag-handle": ""
                      }, [
                        x(T, { class: "tw-w-8 tw-h-8" })
                      ], 8, yc)) : L("", !0)
                    ]),
                    x(dc, {
                      ref_for: !0,
                      ref: v(h).set,
                      "source-content-sequence-id": e.contentSequenceId,
                      item: Y,
                      level: Pe,
                      "order-changes": te.value,
                      "allow-insertion": be === 0,
                      "onUpdate:speakersText": (ce) => Y.speakersText = ce,
                      "onUpdate:internalNote": (ce) => Y.internalNote = ce,
                      "onUpdate:audiofileId": (ce) => Y.audiofileId = ce,
                      "onUpdate:nestedSequenceId": (ce) => z(Y, ce),
                      onInsert: (ce) => v(s)(() => v(Lr)(o.value, e.contentSequenceId, Y, ce)),
                      onCopy: (ce) => v(s)(() => v(Hr)(o.value, Y, e.contentSequenceId)),
                      onDelete: (ce) => v(s)(() => v(Ur)(o.value, Y, e.contentSequenceId))
                    }, null, 8, ["source-content-sequence-id", "item", "level", "order-changes", "allow-insertion", "onUpdate:speakersText", "onUpdate:internalNote", "onUpdate:audiofileId", "onUpdate:nestedSequenceId", "onInsert", "onCopy", "onDelete"])
                  ])
                ], 64))), 128))
              ], 8, gc)
            ]),
            _: 1
          }, 8, ["list", "item-key", "options"])) : L("", !0)
        ], 2)
      ]);
    };
  }
});
const Cc = /* @__PURE__ */ Fe(Sc, [["__scopeId", "data-v-6ee30401"]]), Dc = {
  audio: {
    select: "Select Audiofile",
    searchHint: "Search for existing audiofiles by title or description.",
    searchPlaceholder: "e.g. funds"
  },
  builder: {
    save: "Save",
    undo: "Undo last change",
    redo: "Redo last change",
    hideSpeakerTexts: "Hide speaker texts",
    showSpeakerTexts: "Show speaker texts",
    hideNotes: "Hide notes",
    showNotes: "Show notes"
  },
  generic: {
    edit: "Edit",
    move: "Move",
    close: "Close",
    loading: "Loading data...",
    noResults: "No results found",
    endOfResults: "You\u2019ve reached the end",
    deassign: "Unassign",
    delete: "Delete"
  },
  sequence: {
    searchPlaceholder: "e.g. funds",
    searchHint: "Search for existing schedules by title or description.",
    select: "Embed this schedule",
    selectLabel: "Embed schedule",
    deassign: "Unassign embedded schedule"
  },
  sequenceItem: {
    internalNote: "Internal Note",
    speakersText: "Speaker Text",
    relativeStartTime: "Relative start time",
    relativeStartTimeIssue: "The start time begins earlier than one of the previous items with a defined start time. Please re-order your items or fix the start time. Items with a defined start time are highlighted in purple.",
    createCopy: "Create Local Copy",
    insertFirst: "Add first item",
    insertBefore: "Insert new item before this one",
    insertAfter: "Insert new item after this one"
  }
}, Pc = {
  audio: {
    select: "Audiodatei ausw\xE4hlen",
    searchHint: "Suche nach Titel oder Beschreibung in existierenden Audiodateien.",
    searchPlaceholder: "z.B. Gelder"
  },
  builder: {
    save: "Speichern",
    undo: "Letzte \xC4nderung zur\xFCcknehmen",
    redo: "\xC4nderung erneut anwenden",
    hideSpeakerTexts: "Sprecher*innentexte verstecken",
    showSpeakerTexts: "Sprecher*innentexte anzeigen",
    hideNotes: "Notizen verstecken",
    showNotes: "Notizen anzeigen"
  },
  generic: {
    edit: "Bearbeiten",
    move: "Verschieben",
    close: "Schlie\xDFen",
    loading: "Lade Daten...",
    noResults: "Keine Ergebnisse gefunden",
    endOfResults: "Du hast das Ende erreicht",
    deassign: "Zuordnung aufheben",
    delete: "L\xF6schen"
  },
  sequence: {
    searchPlaceholder: "z.B. Gelder",
    searchHint: "Suche nach Titel oder Beschreibung in existierenden Sendepl\xE4nen.",
    select: "Diesen Sendeplan einbetten",
    selectLabel: "Sendeplan einbetten",
    deassign: "Sendeplaneinbettung entfernen"
  },
  sequenceItem: {
    internalNote: "Interne Notiz",
    speakersText: "Sprecher*innentext",
    relativeStartTime: "Relative Startzeit",
    relativeStartTimeIssue: "Die Startzeit liegt vor der eines fr\xFCheren Eintrags mit festgelegter Zeit. Bitte sortiere die Eintr\xE4ge um oder \xE4ndere die Startzeit. Eintr\xE4ge mit festgelegter Startzeit sind in violetter Farbe hervorgehoben.",
    createCopy: "Lokale Kopie anlegen",
    insertFirst: "Ersten Eintrag hinzuf\xFCgen",
    insertBefore: "Neuen Eintrag vor diesem einf\xFCgen",
    insertAfter: "Neuen Eintrag nach diesem einf\xFCgen"
  }
};
export {
  Cc as ContentSequenceBuilder,
  Pc as de,
  Dc as en,
  $c as fixturesAPI,
  Tc as lohrothekAPI
};
//# sourceMappingURL=content-sequence-builder.js.map
